(function () {


const $3246626f326b5786$export$28ee1007e174a2a6 = (callback)=>{
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};


/**
 * Swiper 14.4.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 30, 2026
 */ function $1a1b1b27ad713891$export$db3b6bfb95261072(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $1a1b1b27ad713891$export$4368d992c4eafac0(obj) {
    Object.keys(obj).forEach((key)=>{
        try {
            obj[key] = null;
        } catch  {
        // no getter for object
        }
        try {
            delete obj[key];
        } catch  {
        // something got wrong
        }
    });
}
function $1a1b1b27ad713891$export$3b14a55fb2447963(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $1a1b1b27ad713891$export$90a7f3efeed30595() {
    return Date.now();
}
function $1a1b1b27ad713891$var$getComputedStyle(el) {
    return window.getComputedStyle(el, null);
}
function $1a1b1b27ad713891$export$9e5f44173e64f162(el, axis = 'x') {
    const style = $1a1b1b27ad713891$var$getComputedStyle(el);
    const transform = style.transform || style.webkitTransform;
    if (!transform || transform === 'none') return 0;
    const matrix = new DOMMatrixReadOnly(transform);
    return axis === 'x' ? matrix.m41 : matrix.m42;
}
function $1a1b1b27ad713891$export$2408f22a0fab9ae5(o) {
    // `constructor === Object` would be false for a plain object created in another realm
    // (params built in the parent page, Swiper running inside an iframe), which makes extend()
    // replace a nested defaults object instead of merging into it.
    return typeof o === 'object' && o !== null && !!o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $1a1b1b27ad713891$export$43caf9889c228507(el) {
    // A bare `instanceof HTMLElement` is false for an element from another window (same-origin
    // iframe, e.g. the WordPress block editor canvas), so check against the element's own realm.
    if (!el || typeof el !== 'object') return false;
    const view = el.ownerDocument?.defaultView;
    const Ctor = view?.HTMLElement ?? (typeof HTMLElement !== 'undefined' ? HTMLElement : undefined);
    return !!Ctor && el instanceof Ctor;
}
function $1a1b1b27ad713891$var$isNode(node) {
    if (typeof HTMLElement !== 'undefined' && node instanceof HTMLElement) return true;
    return !!node && typeof node === 'object' && (node.nodeType === 1 || node.nodeType === 11);
}
function $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5(target, ...sources) {
    const to = Object(target);
    for(let i = 0; i < sources.length; i += 1){
        const nextSource = sources[i];
        if (nextSource === undefined || nextSource === null || $1a1b1b27ad713891$var$isNode(nextSource)) continue;
        const sourceObj = nextSource;
        const keysArray = Object.keys(Object(sourceObj));
        for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
            const nextKey = keysArray[nextIndex];
            if (nextKey === '__proto__' || nextKey === 'constructor' || nextKey === 'prototype') continue;
            const desc = Object.getOwnPropertyDescriptor(sourceObj, nextKey);
            if (!desc || !desc.enumerable) continue;
            const sourceVal = sourceObj[nextKey];
            if ($1a1b1b27ad713891$export$2408f22a0fab9ae5(to[nextKey]) && $1a1b1b27ad713891$export$2408f22a0fab9ae5(sourceVal)) {
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else if (!$1a1b1b27ad713891$export$2408f22a0fab9ae5(to[nextKey]) && $1a1b1b27ad713891$export$2408f22a0fab9ae5(sourceVal)) {
                to[nextKey] = {};
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else to[nextKey] = sourceVal;
        }
    }
    return to;
}
function $1a1b1b27ad713891$export$efccba1c4a2ef57b(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $1a1b1b27ad713891$export$ffb5f4729a158638(slideEl) {
    const direct = slideEl.querySelector('.swiper-slide-transform');
    if (direct) return direct;
    if (slideEl.shadowRoot) {
        const shadowed = slideEl.shadowRoot.querySelector('.swiper-slide-transform');
        if (shadowed) return shadowed;
    }
    return slideEl;
}
function $1a1b1b27ad713891$export$f1e1789686576879(element, selector = '') {
    const children = [
        ...element.children
    ];
    if (element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    return selector ? children.filter((el)=>el.matches(selector)) : children;
}
function $1a1b1b27ad713891$var$elementIsChildOfSlot(el, slot) {
    const queue = [
        slot
    ];
    while(queue.length > 0){
        const cur = queue.shift();
        if (el === cur) return true;
        queue.push(...cur.children, ...cur.shadowRoot ? cur.shadowRoot.children : [], ...cur.assignedElements ? cur.assignedElements() : []);
    }
    return false;
}
function $1a1b1b27ad713891$export$2d1720544b23b823(el, parent) {
    let isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $1a1b1b27ad713891$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $1a1b1b27ad713891$export$4a5767248b18ef41(text) {
    try {
        console.warn(text);
    } catch  {
    // err
    }
}
function $1a1b1b27ad713891$export$407448d2b89b1813(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $1a1b1b27ad713891$export$db3b6bfb95261072(classes));
    return el;
}
// Viewport-relative on purpose: every caller either compares against viewport quantities
// or adds window.scrollX/Y itself, so folding the scroll offset in here double-counts.
function $1a1b1b27ad713891$export$dda1d9f60106f0e9(el) {
    const box = el.getBoundingClientRect();
    return {
        top: box.top - (el.clientTop || 0),
        left: box.left - (el.clientLeft || 0)
    };
}
function $1a1b1b27ad713891$export$342063e11d6c3cad(el, selector) {
    const prevEls = [];
    let prev = el.previousElementSibling;
    while(prev){
        if (!selector || prev.matches(selector)) prevEls.push(prev);
        prev = prev.previousElementSibling;
    }
    return prevEls;
}
function $1a1b1b27ad713891$export$39b482c5e57630a8(el, selector) {
    const nextEls = [];
    let next = el.nextElementSibling;
    while(next){
        if (!selector || next.matches(selector)) nextEls.push(next);
        next = next.nextElementSibling;
    }
    return nextEls;
}
function $1a1b1b27ad713891$export$882b5998b3b9117c(el, prop) {
    return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function $1a1b1b27ad713891$export$8b22cf2602fb60ce(el) {
    if (!el || !el.parentNode) return undefined;
    return [
        ...el.parentNode.children
    ].indexOf(el);
}
function $1a1b1b27ad713891$export$35e795649ee09318(el, selector) {
    const parents = [];
    let parent = el.parentElement;
    while(parent){
        if (!selector || parent.matches(selector)) parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $1a1b1b27ad713891$export$953cecd6e717a553(el, callback) {
    if (!callback) return;
    el.addEventListener('transitionend', function fireCallBack(e) {
        if (e.target !== el) return;
        el.removeEventListener('transitionend', fireCallBack);
        callback.call(el, e);
    });
}
function $1a1b1b27ad713891$export$23f2a1d2818174ef(el, size, includeMargins) {
    {
        const style = window.getComputedStyle(el, null);
        return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    }
}
function $1a1b1b27ad713891$export$625550452a3fa3ec(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $1a1b1b27ad713891$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $1a1b1b27ad713891$export$d141bba7fdc215a3(el, html = '') {
    const tt = globalThis.trustedTypes;
    if (typeof tt !== 'undefined') el.innerHTML = tt.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $43dd4af6d8c862b5$var$supportCached;
function $43dd4af6d8c862b5$var$calcSupport() {
    if (typeof window === 'undefined') return {
        touch: false
    };
    return {
        touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0
    };
}
function $43dd4af6d8c862b5$var$getSupport() {
    if (!$43dd4af6d8c862b5$var$supportCached) $43dd4af6d8c862b5$var$supportCached = $43dd4af6d8c862b5$var$calcSupport();
    return $43dd4af6d8c862b5$var$supportCached;
}
let $43dd4af6d8c862b5$var$deviceCached;
function $43dd4af6d8c862b5$var$calcDevice({ userAgent: userAgent } = {}) {
    if (typeof window === 'undefined') return {
        ios: false,
        android: false
    };
    const support = $43dd4af6d8c862b5$var$getSupport();
    const platform = navigator.platform;
    const ua = userAgent || navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
    const isIPhoneOrIPod = /(iPhone\sOS|iOS|iPod)/.test(ua);
    const isIPadDirect = /iPad/.test(ua);
    // iPad on iPadOS 13+ reports as MacIntel; distinguish from a real Mac by touch capability.
    const isIPadMasquerade = platform === 'MacIntel' && support.touch && navigator.maxTouchPoints > 1;
    const isIPad = isIPadDirect || isIPadMasquerade;
    const isWindows = platform === 'Win32';
    if (isAndroid && !isWindows) {
        device.os = 'android';
        device.android = true;
    }
    if (isIPad || isIPhoneOrIPod) {
        device.os = 'ios';
        device.ios = true;
    }
    return device;
}
function $43dd4af6d8c862b5$var$getDevice(overrides = {}) {
    if (!$43dd4af6d8c862b5$var$deviceCached) $43dd4af6d8c862b5$var$deviceCached = $43dd4af6d8c862b5$var$calcDevice(overrides);
    return $43dd4af6d8c862b5$var$deviceCached;
}
let $43dd4af6d8c862b5$var$browserCached;
function $43dd4af6d8c862b5$var$calcBrowser() {
    if (typeof window === 'undefined') return {
        isSafari: false,
        isWebView: false,
        need3dFix: false
    };
    const device = $43dd4af6d8c862b5$var$getDevice();
    const ua = navigator.userAgent;
    const uaLower = ua.toLowerCase();
    const isSafari = uaLower.includes('safari') && !uaLower.includes('chrome') && !uaLower.includes('android');
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
    // 3D transform glitches still affect iOS WebView and Safari at the baseline (16.4+).
    const need3dFix = isSafari || isWebView && device.ios;
    return {
        isSafari: isSafari,
        isWebView: isWebView,
        need3dFix: need3dFix
    };
}
function $43dd4af6d8c862b5$var$getBrowser() {
    if (!$43dd4af6d8c862b5$var$browserCached) $43dd4af6d8c862b5$var$browserCached = $43dd4af6d8c862b5$var$calcBrowser();
    return $43dd4af6d8c862b5$var$browserCached;
}
const $43dd4af6d8c862b5$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params || !swiper.params.lazyPreload) return;
    const slideSelector = ()=>swiper.isElement ? 'swiper-slide' : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    const innerLazy = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (innerLazy && !innerLazy.lazyPreloaderManaged) innerLazy.remove();
                }
            });
        }
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
const $43dd4af6d8c862b5$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $43dd4af6d8c862b5$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params || !swiper.params.lazyPreload) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && (swiper.params.grid.rows ?? 1) > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>activeColumn + slidesPerView + i));
        swiper.slides.forEach((slideEl, i)=>{
            if (slideEl.column !== undefined && preloadColumns.includes(slideEl.column)) $43dd4af6d8c862b5$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $43dd4af6d8c862b5$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $43dd4af6d8c862b5$var$unlazy(swiper, i);
    }
};
function $43dd4af6d8c862b5$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(String(a.value), 10) - parseInt(String(b.value), 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
const $43dd4af6d8c862b5$var$isGridEnabled = (swiper, params)=>{
    return !!(swiper.grid && params.grid && params.grid.rows > 1);
};
function $43dd4af6d8c862b5$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointsRecord = breakpoints;
    const breakpointOnlyParams = breakpoint in breakpointsRecord ? breakpointsRecord[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $43dd4af6d8c862b5$var$isGridEnabled(swiper, params);
    const isMultiRow = $43dd4af6d8c862b5$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    const moduleOpt = (opts, prop)=>opts[prop];
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const bpOpts = moduleOpt(breakpointParams, prop);
        if (typeof bpOpts === 'undefined') return;
        const paramsOpts = moduleOpt(params, prop);
        const wasModuleEnabled = typeof paramsOpts === 'object' && paramsOpts !== null && paramsOpts.enabled;
        const isModuleEnabled = typeof bpOpts === 'object' && bpOpts !== null && bpOpts.enabled;
        const moduleApi = swiper[prop];
        if (wasModuleEnabled && !isModuleEnabled) moduleApi?.disable?.();
        if (!wasModuleEnabled && isModuleEnabled) moduleApi?.enable?.();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        // Lay out with the new params before loopCreate(), so loopFix() sees current sizes and
        // isLocked state (a slider locked by watchOverflow skips loop entirely, #8228)
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.updateSlides();
            swiper.loopCreate(realIndex);
        } else if (!wasLoop && hasLoop) {
            swiper.updateSlides();
            swiper.loopCreate(realIndex);
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
var $43dd4af6d8c862b5$var$breakpoints = {
    setBreakpoint: $43dd4af6d8c862b5$var$setBreakpoint,
    getBreakpoint: $43dd4af6d8c862b5$var$getBreakpoint
};
function $43dd4af6d8c862b5$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $43dd4af6d8c862b5$var$checkOverflow$1 = {
    checkOverflow: $43dd4af6d8c862b5$var$checkOverflow
};
function $43dd4af6d8c862b5$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $43dd4af6d8c862b5$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // oxfmt-ignore
    const suffixes = $43dd4af6d8c862b5$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $43dd4af6d8c862b5$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $43dd4af6d8c862b5$var$classes = {
    addClasses: $43dd4af6d8c862b5$var$addClasses,
    removeClasses: $43dd4af6d8c862b5$var$removeClasses
};
const $43dd4af6d8c862b5$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreload: true,
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
var $43dd4af6d8c862b5$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const onceHandler = function onceHandlerFn(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        };
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            const opts = args[0];
            events = opts.events;
            data = opts.data ?? [];
            context = opts.context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $43dd4af6d8c862b5$var$onClick(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $43dd4af6d8c862b5$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.destroyed) return;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
function $43dd4af6d8c862b5$var$onLoad(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    $43dd4af6d8c862b5$var$processLazyPreloader(swiper, e.target);
    if (e.type === 'error' || swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $43dd4af6d8c862b5$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // updateSlides() measures slides with their margins reset, and WebKit re-snaps the wrapper after
    // that layout - applying it after the re-seat below, short of the slide by the margins before it.
    // Keep snapping off until the next frame, as slideTo() does for virtual slides.
    const { wrapperEl: wrapperEl } = swiper;
    const snapType = params.cssMode && wrapperEl ? wrapperEl.style.scrollSnapType : 'none';
    if (snapType !== 'none') {
        wrapperEl.style.scrollSnapType = 'none';
        requestAnimationFrame(()=>{
            if (!swiper.destroyed) wrapperEl.style.scrollSnapType = snapType;
        });
    }
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
        const slidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
        swiper.slideTo(slidesLength - 1, 0, false, true);
    } else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    // In cssMode the re-seat only writes the scroll position, and where the browser had already put
    // the wrapper there no scroll event follows to bring translate and progress up to date.
    if (params.cssMode && swiper.onScroll) swiper.onScroll();
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        const autoplay = swiper.autoplay;
        clearTimeout(autoplay.resizeTimeout);
        autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $43dd4af6d8c862b5$var$measureSize(swiper) {
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return null;
    // Subtract paddings
    width = width - parseInt((0, $1a1b1b27ad713891$export$882b5998b3b9117c)(el, 'padding-left') || '0', 10) - parseInt((0, $1a1b1b27ad713891$export$882b5998b3b9117c)(el, 'padding-right') || '0', 10);
    height = height - parseInt((0, $1a1b1b27ad713891$export$882b5998b3b9117c)(el, 'padding-top') || '0', 10) - parseInt((0, $1a1b1b27ad713891$export$882b5998b3b9117c)(el, 'padding-bottom') || '0', 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    return {
        width: width,
        height: height
    };
}
// Whether the container changed size along the slider since updateSize(), with the ResizeObserver
// still to hand the change to onResize() on the next animation frame.
function $43dd4af6d8c862b5$var$isResizePending(swiper) {
    const { params: params, el: el } = swiper;
    if (!params.updateOnWindowResize || !params.resizeObserver || typeof window.ResizeObserver === 'undefined') return false;
    const isH = swiper.isHorizontal();
    const clientSize = isH ? el.clientWidth : el.clientHeight;
    if (clientSize === swiper._clientSize) return false;
    // clientWidth includes the padding, the ResizeObserver only sees the content box: a padding
    // change alone leaves the slide grid as it was, and no onResize() follows to measure it.
    const measured = $43dd4af6d8c862b5$var$measureSize(swiper);
    if (!measured || (isH ? measured.width : measured.height) !== swiper.size) return true;
    swiper._clientSize = clientSize;
    return false;
}
function $43dd4af6d8c862b5$var$updateSize() {
    const swiper = this;
    const el = swiper.el;
    const measured = $43dd4af6d8c862b5$var$measureSize(swiper);
    if (!measured) return;
    const { width: width, height: height } = measured;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height,
        _clientSize: swiper.isHorizontal() ? el.clientWidth : el.clientHeight
    });
}
function $43dd4af6d8c862b5$var$onScroll() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    // A resize moves the scroll position (re-snap, clamp) before onResize() measures the new layout;
    // read against the old slide grid it names another slide. Leave it to onResize(), which keeps
    // the slider on its slide. Browsers fire it before or after the ResizeObserver, so check the size.
    if ($43dd4af6d8c862b5$var$isResizePending(swiper)) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $43dd4af6d8c862b5$var$onTouchEnd(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    let e = event.originalEvent ?? event;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId) return;
    } else {
        const te = e;
        const found = [
            ...te.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    data.startEventPath = undefined;
    data.lastMoveEvent = undefined;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $1a1b1b27ad713891$export$90a7f3efeed30595)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        // Legacy `e.path` was a non-standard Chrome extension; `composedPath()` is the modern API.
        const pathTree = e.path ?? (e.composedPath && e.composedPath());
        swiper.updateClickedSlide(pathTree && pathTree[0], pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $1a1b1b27ad713891$export$90a7f3efeed30595)();
    (0, $1a1b1b27ad713891$export$3b14a55fb2447963)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -(data.currentTranslate ?? 0);
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual?.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $43dd4af6d8c862b5$var$onTouchMove(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    // Legacy event wrappers nest the native event under .originalEvent.
    const wrapped = event;
    const e = wrapped.originalEvent ?? wrapped;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        const te = e;
        const found = [
            ...te.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId) return;
        targetTouch = found;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    // Nested swipers listen on document in capture phase, so they run in registration order and
    // an ancestor initialized first would move before its descendant can set
    // preventedByNestedSwiper. Run touched nested descendants first, innermost to outermost.
    if (data.lastMoveEvent === e) return;
    data.lastMoveEvent = e;
    for (const node of data.startEventPath ?? []){
        if (node === swiper.el) break;
        const child = node.swiper;
        if (child && child !== swiper && !child.destroyed && child.params.nested && child.touchEventsData.isTouched) child.onTouchMove(event);
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $1a1b1b27ad713891$export$90a7f3efeed30595)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') document.activeElement.blur();
    if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    // startTranslate is guaranteed to be set by this point (set in onTouchStart-side init).
    const startTranslate = data.startTranslate ?? 0;
    data.currentTranslate = diff + startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(String(params.slidesPerView))))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && (data.currentTranslate ?? 0) < startTranslate) data.currentTranslate = startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && (data.currentTranslate ?? 0) > startTranslate) data.currentTranslate = startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate ?? 0);
}
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $43dd4af6d8c862b5$var$closestElement(selector, base) {
    function __closestFrom(el) {
        if (!el || el === document || el === window) return null;
        let cur = el;
        if (cur.assignedSlot) cur = cur.assignedSlot;
        const found = cur.closest(selector);
        if (!found && !cur.getRootNode) return null;
        const root = cur.getRootNode();
        return found || __closestFrom(root.host);
    }
    return __closestFrom(base);
}
function $43dd4af6d8c862b5$var$preventEdgeSwipe(swiper, event, startX) {
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $43dd4af6d8c862b5$var$onTouchStart(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const e = event.originalEvent ?? event;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        const pe = e;
        if (data.pointerId !== null && data.pointerId !== pe.pointerId) return;
        data.pointerId = pe.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $43dd4af6d8c862b5$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $1a1b1b27ad713891$export$2d1720544b23b823)(targetEl, swiper.wrapperEl)) return;
    }
    // Secondary mouse buttons (right-click / middle-click) shouldn't start a swipe.
    const mouseLike = e;
    if (typeof mouseLike.which === 'number' && mouseLike.which === 3) return;
    if (typeof mouseLike.button === 'number' && mouseLike.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // `path` is a non-standard Chrome extension; `composedPath()` is the modern API.
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $43dd4af6d8c862b5$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (typeof params.swipeHandler === 'string' && !targetEl.closest(params.swipeHandler)) return;
    }
    // At this point `e` is a PointerEvent or MouseEvent (touchstart returned earlier).
    const pe = e;
    touches.currentX = pe.pageX;
    touches.currentY = pe.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$43dd4af6d8c862b5$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $1a1b1b27ad713891$export$90a7f3efeed30595)();
    data.startEventPath = eventPath;
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (pe.pointerType === 'mouse' || pe.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
const $43dd4af6d8c862b5$var$events = (swiper, method)=>{
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    const subscribe = (events)=>{
        swiper[swiperMethod](events, $43dd4af6d8c862b5$var$onResize, true);
    };
    if (params.updateOnWindowResize) subscribe(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate');
    else subscribe('observerUpdate');
    // Images loader
    if (params.lazyPreload) {
        el[domMethod]('load', swiper.onLoad, {
            capture: true
        });
        el[domMethod]('error', swiper.onLoad, {
            capture: true
        });
    }
};
function $43dd4af6d8c862b5$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $43dd4af6d8c862b5$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $43dd4af6d8c862b5$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $43dd4af6d8c862b5$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $43dd4af6d8c862b5$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $43dd4af6d8c862b5$var$onScroll.bind(swiper);
    swiper.onClick = $43dd4af6d8c862b5$var$onClick.bind(swiper);
    swiper.onLoad = $43dd4af6d8c862b5$var$onLoad.bind(swiper);
    $43dd4af6d8c862b5$var$events(swiper, 'on');
}
function $43dd4af6d8c862b5$var$detachEvents() {
    const swiper = this;
    $43dd4af6d8c862b5$var$events(swiper, 'off');
}
var $43dd4af6d8c862b5$var$events$1 = {
    attachEvents: $43dd4af6d8c862b5$var$attachEvents,
    detachEvents: $43dd4af6d8c862b5$var$detachEvents
};
function $43dd4af6d8c862b5$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $43dd4af6d8c862b5$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $43dd4af6d8c862b5$var$grabCursor = {
    setGrabCursor: $43dd4af6d8c862b5$var$setGrabCursor,
    unsetGrabCursor: $43dd4af6d8c862b5$var$unsetGrabCursor
};
function $43dd4af6d8c862b5$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual?.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $1a1b1b27ad713891$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', String(index));
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $1a1b1b27ad713891$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $1a1b1b27ad713891$export$407448d2b89b1813)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $1a1b1b27ad713891$export$4a5767248b18ef41)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $1a1b1b27ad713891$export$4a5767248b18ef41)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $43dd4af6d8c862b5$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual?.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const loopSlideEl = slideEl;
        const index = typeof loopSlideEl.swiperSlideIndex === 'undefined' ? Number(slideEl.getAttribute('data-swiper-slide-index')) : loopSlideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
function $43dd4af6d8c862b5$var$loopFix(options = {}) {
    const { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndexParam, initial: initial, byController: byController, byMousewheel: byMousewheel } = options;
    let activeSlideIndex = activeSlideIndexParam;
    const swiper = this;
    if (!swiper.params.loop) return;
    // A locked slider (watchOverflow, all slides fit) can't move, so there is nothing to loop:
    // keep the original slide order and don't warn about too few slides (#8228)
    if (swiper.params.watchOverflow && swiper.isLocked) return;
    swiper.emit('beforeLoopFix');
    // The compensating slideTo() teleports below change indexes/translate without any
    // observable slide change, so updateActiveIndex() must not emit index-change events
    // while this flag is set (otherwise pagination flickers mid-drag, see #8015)
    swiper.__loopFixInProgress__ = true;
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual?.enabled) {
        if (slideTo) {
            const virtualSlidesLength = swiper.virtual.slides.length;
            const virtualSlidesBefore = swiper.virtual.slidesBefore ?? 0;
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(virtualSlidesLength, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(virtualSlidesLength + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(virtualSlidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.__loopFixInProgress__ = false;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(String(params.slidesPerView)));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    // How many slides the before/after offsets are worth. Unlike centeredSlides
    // (which hides ~slidesPerView / 2 slides on each side), an offset hides only
    // offset / slideSize slides, so sizing the loop buffer from slidesPerView / 2
    // would teleport further than the snapGrid allows with few slides (#8203).
    // Offsets accept a legacy function form at runtime (see updateSlides), so
    // narrow before doing math on them.
    const resolveOffset = (value)=>(typeof value === 'function' ? value.call(swiper) : value) || 0;
    const slidesGridStep = swiper.slidesGrid.length > 1 ? (swiper.slidesGrid[swiper.slidesGrid.length - 1] - swiper.slidesGrid[0]) / (swiper.slidesGrid.length - 1) : swiper.size;
    const offsetSlidesBefore = slidesGridStep > 0 ? resolveOffset(slidesOffsetBefore) / slidesGridStep : 0;
    const offsetSlidesAfter = slidesGridStep > 0 ? resolveOffset(slidesOffsetAfter) / slidesGridStep : 0;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, (centeredSlides ? Math.ceil(slidesPerView / 2) : 0) + Math.ceil(Math.max(offsetSlidesBefore, offsetSlidesAfter))) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $1a1b1b27ad713891$export$4a5767248b18ef41)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $1a1b1b27ad713891$export$4a5767248b18ef41)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    // The active slide must be able to sit between loopedSlides on each side; when there are
    // too few slides for that (e.g. loopAdditionalSlides, which the cards effect sets to 2-3),
    // every index falls into the prepend branch and nothing is ever appended, so forward
    // navigation gets stuck (#8008). Shrink the buffer to what the slides can hold, keeping
    // it a whole number of groups and leaving one slide to spare: with none, the forward
    // loopFix in onTouchMove fires right at drag start and appends the active slide itself.
    if (loopedSlides > (cols - slidesPerView) / 2) {
        loopedSlides = Math.max(slidesPerGroup, Math.floor((cols - slidesPerView - 1) / 2 / slidesPerGroup) * slidesPerGroup);
        swiper.loopedSlides = loopedSlides;
    }
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column ?? 0 : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? (centeredSlides ? -slidesPerView / 2 + 0.5 : 0) - offsetSlidesBefore : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        // prepend exactly what the compensating slideTo() below shifts by (like the append branch)
        for(let i = 0; i < slidesPrepended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let j = slides.length - 1; j >= 0; j -= 1)if (slides[j].column === colIndexToPrepend) prependSlidesIndexes.push(j);
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        // The view must still fit inside the slides afterwards. With a forced activeSlideIndex far
        // to the right (slideToLoop) and a buffer shrunk by the cap above, the formula above can
        // come up short and leave the end of the view empty (#8253)
        slidesAppended = Math.max(slidesAppended, Math.ceil(activeColIndexWithShift + slidesPerView - cols));
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        const slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.prepend(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        const slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.append(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    const controlled = swiper.controller?.control;
    if (controlled && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(controlled)) controlled.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (controlled instanceof swiper.constructor && controlled.params.loop) controlled.loopFix({
            ...loopParams,
            slideTo: controlled.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.__loopFixInProgress__ = false;
    swiper.emit('loopFix');
}
var $43dd4af6d8c862b5$var$loop = {
    loopCreate: $43dd4af6d8c862b5$var$loopCreate,
    loopFix: $43dd4af6d8c862b5$var$loopFix,
    loopDestroy: $43dd4af6d8c862b5$var$loopDestroy
};
function $43dd4af6d8c862b5$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
    };
}
const $43dd4af6d8c862b5$var$Observer = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    const observers = [];
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        if (!ObserverFunc) return;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                swiper.emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                swiper.emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options.childList),
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $1a1b1b27ad713891$export$35e795649ee09318)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
};
const $43dd4af6d8c862b5$var$Resize = ({ swiper: swiper, on: on, emit: emit })=>{
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        // Entry sizes come from the layout before the rAF, while onResize() stores the live size in
        // swiper.width/height. Comparing entries against swiper.width therefore skipped every other
        // frame of a continuous resize, painting those frames with a stale translate (#8230), so
        // compare against the last handled entry size instead.
        let observedWidth = swiper.width;
        let observedHeight = swiper.height;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                let newWidth = observedWidth;
                let newHeight = observedHeight;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    // Older Safari (≤15) exposed `contentBoxSize` as a single object instead of an array.
                    const box = Array.isArray(contentBoxSize) ? contentBoxSize[0] : contentBoxSize;
                    newWidth = contentRect ? contentRect.width : box.inlineSize;
                    newHeight = contentRect ? contentRect.height : box.blockSize;
                });
                if (newWidth !== observedWidth || newHeight !== observedHeight) {
                    observedWidth = newWidth;
                    observedHeight = newHeight;
                    resizeHandler();
                }
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
};
function $43dd4af6d8c862b5$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function $43dd4af6d8c862b5$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            // slidesPerViewDynamic('previous') counts from activeIndex, so step from there (stepping
            // from prevSnap's index overshoots by one); always move back at least one slide (#8235)
            const prevSlidesInView = swiper.slidesPerViewDynamic('previous', true) - 1;
            prevIndex = Math.max(swiper.activeIndex - Math.max(prevSlidesInView, 1), 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual?.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function $43dd4af6d8c862b5$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function $43dd4af6d8c862b5$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        // onScroll() leaves the scroll this causes to onResize() while a resize is pending, and
        // onResize() re-seats the slider onto activeIndex - so it has to name this slide already.
        if ($43dd4af6d8c862b5$var$isResizePending(swiper)) swiper.updateActiveIndex(slideIndex);
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && (swiper.params.initialSlide ?? 0) > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: t,
            behavior: 'smooth'
        });
        return true;
    }
    const browser = $43dd4af6d8c862b5$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $43dd4af6d8c862b5$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl, clickedSlide: clickedSlide, clickedIndex: clickedIndex } = swiper;
    if (clickedSlide === undefined || clickedIndex === undefined) return;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $1a1b1b27ad713891$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $1a1b1b27ad713891$export$3b14a55fb2447963)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
function $43dd4af6d8c862b5$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $43dd4af6d8c862b5$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual?.enabled) newIndex = newIndex + (swiper.virtual.slidesBefore ?? 0);
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                targetSlideIndex = targetSlideEl?.column ?? 0;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView;
            if (swiper.params.slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(String(swiper.params.slidesPerView)));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) {
                // A centered target only needs half a view of slides on each side. Asking for a whole
                // view after it makes loopFix rearrange slides that already fit, which with only one
                // slide to spare moves a slide away from the target's side and leaves a gap (#8253)
                const halfView = Math.floor(slidesPerView / 2);
                needLoopFix = targetSlideIndex < halfView || cols - 1 - targetSlideIndex < halfView;
            } else if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                newIndex = targetSlideEl?.column ?? 0;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
var $43dd4af6d8c862b5$var$slide = {
    slideTo: $43dd4af6d8c862b5$var$slideTo,
    slideToLoop: $43dd4af6d8c862b5$var$slideToLoop,
    slideNext: $43dd4af6d8c862b5$var$slideNext,
    slidePrev: $43dd4af6d8c862b5$var$slidePrev,
    slideReset: $43dd4af6d8c862b5$var$slideReset,
    slideToClosest: $43dd4af6d8c862b5$var$slideToClosest,
    slideToClickedSlide: $43dd4af6d8c862b5$var$slideToClickedSlide
};
function $43dd4af6d8c862b5$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $43dd4af6d8c862b5$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $43dd4af6d8c862b5$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $43dd4af6d8c862b5$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
function $43dd4af6d8c862b5$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $43dd4af6d8c862b5$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
var $43dd4af6d8c862b5$var$transition = {
    setTransition: $43dd4af6d8c862b5$var$setTransition,
    transitionStart: $43dd4af6d8c862b5$var$transitionStart,
    transitionEnd: $43dd4af6d8c862b5$var$transitionEnd
};
function $43dd4af6d8c862b5$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $1a1b1b27ad713891$export$9e5f44173e64f162)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $43dd4af6d8c862b5$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $43dd4af6d8c862b5$var$minTranslate() {
    return -this.snapGrid[0];
}
function $43dd4af6d8c862b5$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $43dd4af6d8c862b5$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: -newTranslate,
            behavior: 'smooth'
        });
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $43dd4af6d8c862b5$var$translate = {
    getTranslate: $43dd4af6d8c862b5$var$getSwiperTranslate,
    setTranslate: $43dd4af6d8c862b5$var$setTranslate,
    minTranslate: $43dd4af6d8c862b5$var$minTranslate,
    maxTranslate: $43dd4af6d8c862b5$var$maxTranslate,
    translateTo: $43dd4af6d8c862b5$var$translateTo
};
function $43dd4af6d8c862b5$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $43dd4af6d8c862b5$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        const virtualSlides = swiper.virtual.slides;
        let realIndex = aIndex - (swiper.virtual.slidesBefore ?? 0);
        if (realIndex < 0) realIndex = virtualSlides.length + realIndex;
        if (realIndex >= virtualSlides.length) realIndex -= virtualSlides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $43dd4af6d8c862b5$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual?.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual?.enabled) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $43dd4af6d8c862b5$var$preload(swiper);
    // Loop-fix teleports change indexes without any observable slide change —
    // emitting here would make pagination and other listeners react to transient
    // wrong indexes (#8015). The enclosing slide action emits the final events.
    if (swiper.__loopFixInProgress__) return;
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        // Compare to the realIndex listeners last heard, not to the previous call's
        // value — a suppressed loop-fix call in between would otherwise advance the
        // baseline and swallow (or duplicate) a realIndexChange
        if ((swiper.__lastEmittedRealIndex__ ?? previousRealIndex) !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
    swiper.__lastEmittedRealIndex__ = realIndex;
}
function $43dd4af6d8c862b5$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            const slide = getSlideByIndex(index);
            if (slide) activeSlides.push(slide);
        }
    } else {
        const slide = getSlideByIndex(swiper.activeIndex);
        if (slide) activeSlides.push(slide);
    }
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $43dd4af6d8c862b5$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual?.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
function $43dd4af6d8c862b5$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    let progressLoop = swiper.progressLoop;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
function $43dd4af6d8c862b5$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || '0');
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $1a1b1b27ad713891$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    const resolveOffset = (value)=>typeof value === 'function' ? value.call(swiper) : value;
    const offsetBefore = resolveOffset(params.slidesOffsetBefore);
    const offsetAfter = resolveOffset(params.slidesOffsetAfter);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $1a1b1b27ad713891$export$efccba1c4a2ef57b)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $1a1b1b27ad713891$export$efccba1c4a2ef57b)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $1a1b1b27ad713891$export$efccba1c4a2ef57b)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0, $1a1b1b27ad713891$export$efccba1c4a2ef57b)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize = 0;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        const bp = params.breakpoints[key];
        return typeof bp?.slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $1a1b1b27ad713891$export$882b5998b3b9117c)(slide, 'display') === 'none') continue;
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual?.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $1a1b1b27ad713891$export$23f2a1d2818174ef)(slide, 'width') : (0, $1a1b1b27ad713891$export$23f2a1d2818174ef)(slide, 'height');
            else {
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for(let i = slidesSizesGrid.length - 1; i >= 0; i -= 1){
                    accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        const slidesBefore = swiper.virtual.slidesBefore ?? 0;
        const slidesAfter = swiper.virtual.slidesAfter ?? 0;
        const virtualLoopCount = slidesBefore + slidesAfter;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil(virtualLoopCount / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < virtualLoopCount; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $1a1b1b27ad713891$export$efccba1c4a2ef57b)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $1a1b1b27ad713891$export$efccba1c4a2ef57b)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
const $43dd4af6d8c862b5$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $43dd4af6d8c862b5$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $1a1b1b27ad713891$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            const virtualSlides = swiper.virtual.slides;
            let slideIndex = activeIndex - (swiper.virtual.slidesBefore ?? 0);
            if (slideIndex < 0) slideIndex = virtualSlides.length + slideIndex;
            if (slideIndex >= virtualSlides.length) slideIndex -= virtualSlides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $1a1b1b27ad713891$export$39b482c5e57630a8)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $1a1b1b27ad713891$export$342063e11d6c3cad)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            // NOTE: legacy guard from v9; `(!prevSlide) === 0` is always false, but we preserve
            // the original behaviour (no-op) to avoid runtime changes in v14. Audit candidate.
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $43dd4af6d8c862b5$var$toggleSlideClasses$1(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $43dd4af6d8c862b5$var$toggleSlideClasses$1(slideEl, slideEl === nextSlide, params.slideNextClass);
        $43dd4af6d8c862b5$var$toggleSlideClasses$1(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
function $43dd4af6d8c862b5$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $43dd4af6d8c862b5$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $43dd4af6d8c862b5$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset ?? 0;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset ?? 0;
        const slideSize = slide.swiperSlideSize ?? 0;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $43dd4af6d8c862b5$var$toggleSlideClasses(slide, isVisible, params.slideVisibleClass);
        $43dd4af6d8c862b5$var$toggleSlideClasses(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
var $43dd4af6d8c862b5$var$update = {
    updateSize: $43dd4af6d8c862b5$var$updateSize,
    updateSlides: $43dd4af6d8c862b5$var$updateSlides,
    updateAutoHeight: $43dd4af6d8c862b5$var$updateAutoHeight,
    updateSlidesOffset: $43dd4af6d8c862b5$var$updateSlidesOffset,
    updateSlidesProgress: $43dd4af6d8c862b5$var$updateSlidesProgress,
    updateProgress: $43dd4af6d8c862b5$var$updateProgress,
    updateSlidesClasses: $43dd4af6d8c862b5$var$updateSlidesClasses,
    updateActiveIndex: $43dd4af6d8c862b5$var$updateActiveIndex,
    updateClickedSlide: $43dd4af6d8c862b5$var$updateClickedSlide
};
const $43dd4af6d8c862b5$var$prototypes = {
    eventsEmitter: $43dd4af6d8c862b5$var$eventsEmitter,
    update: $43dd4af6d8c862b5$var$update,
    translate: $43dd4af6d8c862b5$var$translate,
    transition: $43dd4af6d8c862b5$var$transition,
    slide: $43dd4af6d8c862b5$var$slide,
    loop: $43dd4af6d8c862b5$var$loop,
    grabCursor: $43dd4af6d8c862b5$var$grabCursor,
    events: $43dd4af6d8c862b5$var$events$1,
    breakpoints: $43dd4af6d8c862b5$var$breakpoints,
    checkOverflow: $43dd4af6d8c862b5$var$checkOverflow$1,
    classes: $43dd4af6d8c862b5$var$classes
};
const $43dd4af6d8c862b5$var$extendedDefaults = {};
class $43dd4af6d8c862b5$export$25ce5a424b770e84 {
    static extendedDefaults;
    static defaults;
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0] !== null && typeof args[0] === 'object' && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && typeof params.el === 'string' && typeof document !== 'undefined' && document.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)({}, params, {
                    el: containerEl
                });
                swipers.push(new $43dd4af6d8c862b5$export$25ce5a424b770e84(newParams));
            });
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $43dd4af6d8c862b5$var$getSupport();
        swiper.device = $43dd4af6d8c862b5$var$getDevice({
            userAgent: params.userAgent ?? undefined
        });
        swiper.browser = $43dd4af6d8c862b5$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__ || []
        ];
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach((mod)=>{
            const fn = mod;
            if (typeof fn === 'function' && swiper.modules.indexOf(fn) < 0) swiper.modules.push(fn);
        });
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $43dd4af6d8c862b5$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)({}, $43dd4af6d8c862b5$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)({}, swiperParams, $43dd4af6d8c862b5$var$extendedDefaults, params);
        swiper.originalParams = (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)({}, swiper.params);
        swiper.passedParams = (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) {
            const onHandlers = swiper.params.on;
            Object.keys(onHandlers).forEach((eventName)=>{
                const handler = onHandlers[eventName];
                if (handler) swiper.on(eventName, handler);
            });
        }
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // oxfmt-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    /**
     * !INTERNAL
     */ isHorizontal() {
        return this.params.direction === 'horizontal';
    }
    isVertical() {
        return this.params.direction === 'vertical';
    }
    cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $1a1b1b27ad713891$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $1a1b1b27ad713891$export$8b22cf2602fb60ce)(slides[0]);
        return (0, $1a1b1b27ad713891$export$8b22cf2602fb60ce)(slideEl) - (firstSlideIndex ?? 0);
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const { slidesEl: slidesEl, params: params } = this;
        this.slides = (0, $1a1b1b27ad713891$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    /**
     * Enable Swiper (if it was disabled)
     */ enable() {
        if (this.enabled) return;
        this.enabled = true;
        if (this.params.grabCursor) this.setGrabCursor();
        this.emit('enable');
    }
    /**
     * Disable Swiper (if it was enabled). When Swiper is disabled, it will hide all navigation elements and won't respond to any events and interactions
     */ disable() {
        if (!this.enabled) return;
        this.enabled = false;
        if (this.params.grabCursor) this.unsetGrabCursor();
        this.emit('disable');
    }
    /**
     * Set Swiper translate progress (from 0 to 1). Where 0 - its initial position (offset) on first slide, and 1 - its maximum position (offset) on last slide
     *
     * @param progress Swiper translate progress (from 0 to 1).
     * @param speed Transition duration (in ms).
     */ setProgress(progress, speed) {
        progress = Math.min(Math.max(progress, 0), 1);
        const min = this.minTranslate();
        const max = this.maxTranslate();
        const current = (max - min) * progress + min;
        this.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        this.updateActiveIndex();
        this.updateSlidesClasses();
    }
    emitContainerClasses() {
        if (!this.params._emitClasses || !this.el) return;
        const cls = this.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(this.params.containerModifierClass) === 0;
        });
        this.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        if (this.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(this.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        if (!this.params._emitClasses || !this.el) return;
        const updates = [];
        this.slides.forEach((slideEl)=>{
            const classNames = this.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            this.emit('_slideClass', slideEl, classNames);
        });
        this.emit('_slideClasses', updates);
    }
    /**
     * Get dynamically calculated amount of slides per view, useful only when slidesPerView set to `auto`
     */ slidesPerViewDynamic(view = 'current', exact = false) {
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = this;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        // container not measured yet — centered branch below would never break and return ~slides.length (#7586)
        if (!swiperSize) return spv;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize ?? 0) : 0;
            let breakLoop = false;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize ?? 0);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize ?? 0;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
            const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) spv += 1;
        }
        else // previous
        for(let i = activeIndex - 1; i >= 0; i -= 1){
            const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
            if (slideInView) spv += 1;
        }
        return spv;
    }
    /**
     * You should call it after you add/remove slides
     * manually, or after you hide/show it, or do any
     * custom DOM modifications with Swiper
     * This method also includes subcall of the following
     * methods which you can use separately:
     */ update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        if (params.lazyPreload) [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $43dd4af6d8c862b5$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        // A hidden container may not have a size yet. Defer layout and index updates
        // until it can be measured (or an explicit width/height is supplied).
        if (typeof swiper.size === 'undefined') {
            swiper.emit('update');
            return;
        }
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode?.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slidesLength = swiper.virtual && params.virtual?.enabled ? swiper.virtual.slides.length : swiper.slides.length;
                translated = swiper.slideTo(slidesLength - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    /**
     * Changes slider direction from horizontal to vertical and back.
     *
     * @param direction New direction. If not specified, then will automatically changed to opposite direction
     * @param needUpdate Will call swiper.update(). Default true
     */ changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        // RTL only inverts the translate axis while horizontal, so recompute the flag here —
        // a stale `true` flips the sign of every translate read on a vertical slider.
        swiper.rtlTranslate = newDirection === 'horizontal' && swiper.rtl;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    /**
     * Changes slider language
     *
     * @param direction New direction. Should be `rtl` or `ltr`
     */ changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // No DOM (SSR / Node) — nothing to mount to.
        if (typeof document === 'undefined') return false;
        // Find el (params.el can be a CSSSelector, HTMLElement, or undefined)
        const initialEl = element ?? swiper.params.el;
        let el = null;
        if (typeof initialEl === 'string') el = document.querySelector(initialEl);
        else if ((0, $1a1b1b27ad713891$export$43caf9889c228507)(initialEl)) el = initialEl;
        if (!el) return false;
        el.swiper = swiper;
        const parent = el.parentNode;
        if (parent && parent.host && parent.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $1a1b1b27ad713891$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $1a1b1b27ad713891$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        const host = swiper.isElement ? el.parentNode.host : null;
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !host.slideSlots ? host : wrapperEl,
            hostEl: swiper.isElement ? host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $1a1b1b27ad713891$export$882b5998b3b9117c)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $1a1b1b27ad713891$export$882b5998b3b9117c)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $1a1b1b27ad713891$export$882b5998b3b9117c)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    /**
     * Initialize slider
     */ init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual?.enabled) swiper.slideTo((swiper.params.initialSlide ?? 0) + (swiper.virtual.slidesBefore ?? 0), 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        if (swiper.params.lazyPreload) {
            const lazyElements = [
                ...swiper.el.querySelectorAll('[loading="lazy"]')
            ];
            if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
            lazyElements.forEach((imageEl)=>{
                // Not-yet-complete images are handled by the delegated `load`/`error` listener in attachEvents()
                if (imageEl.complete) $43dd4af6d8c862b5$var$processLazyPreloader(swiper, imageEl);
            });
        }
        // Init Flag
        swiper.initialized = true;
        $43dd4af6d8c862b5$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    /**
     * Destroy slider instance and detach all events listeners
     *
     * @param deleteInstance Set it to false (by default it is true) to not to delete Swiper instance
     * @param cleanStyles Set it to true (by default it is true) and all custom styles will be removed from slides, wrapper and container.
     * Useful if you need to destroy Swiper and to init again with new options or in different direction
     */ destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $1a1b1b27ad713891$export$4368d992c4eafac0)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $1a1b1b27ad713891$export$7ccc53e8f1e7dfc5)($43dd4af6d8c862b5$var$extendedDefaults, newDefaults);
    }
    static installModule(mod) {
        if (!$43dd4af6d8c862b5$export$25ce5a424b770e84.prototype.__modules__) $43dd4af6d8c862b5$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $43dd4af6d8c862b5$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$43dd4af6d8c862b5$export$25ce5a424b770e84.installModule(m));
            return $43dd4af6d8c862b5$export$25ce5a424b770e84;
        }
        $43dd4af6d8c862b5$export$25ce5a424b770e84.installModule(module);
        return $43dd4af6d8c862b5$export$25ce5a424b770e84;
    }
}
Object.defineProperty($43dd4af6d8c862b5$export$25ce5a424b770e84, 'extendedDefaults', {
    get () {
        return $43dd4af6d8c862b5$var$extendedDefaults;
    }
});
Object.defineProperty($43dd4af6d8c862b5$export$25ce5a424b770e84, 'defaults', {
    get () {
        return $43dd4af6d8c862b5$export$4368d992c4eafac0;
    }
});
// Attach prototype-mixin method groups onto Swiper.prototype. Each group is a
// plain record of method-name → function; we copy them across as-is.
const $43dd4af6d8c862b5$var$prototypeRecord = $43dd4af6d8c862b5$var$prototypes;
const $43dd4af6d8c862b5$var$swiperProto = $43dd4af6d8c862b5$export$25ce5a424b770e84.prototype;
Object.keys($43dd4af6d8c862b5$var$prototypeRecord).forEach((prototypeGroup)=>{
    const group = $43dd4af6d8c862b5$var$prototypeRecord[prototypeGroup];
    Object.keys(group).forEach((protoMethod)=>{
        $43dd4af6d8c862b5$var$swiperProto[protoMethod] = group[protoMethod];
    });
});
$43dd4af6d8c862b5$export$25ce5a424b770e84.use([
    $43dd4af6d8c862b5$var$Resize,
    $43dd4af6d8c862b5$var$Observer
]);





const $83c681b69a11427e$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    // Methods (appendSlide/prependSlide/removeSlide/removeAllSlides/update) are
    // attached via Object.assign below once they're defined. Cast through
    // Partial<> so the initial state-only literal can be assigned without
    // pretending the methods exist yet.
    swiper.virtual = {
        cache: {},
        from: 0,
        // -1 marks "nothing rendered yet": no real update can produce to < from,
        // so the first update() never mistakes slide 0 for an already-rendered
        // slide and always appends the full [from, to] window (#8202).
        to: -1,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function getParams() {
        return swiper.params.virtual;
    }
    // Created lazily so module init does not touch the DOM (SSR / Node safe).
    let tempDOM;
    const getTempDOM = ()=>tempDOM ??= document.createElement('div');
    function renderSlide(slide, index) {
        const params = getParams();
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        let slideEl;
        if (params.renderSlide) {
            const rendered = params.renderSlide.call(swiper, slide, index);
            if (typeof rendered === 'string') {
                const el = getTempDOM();
                (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(el, rendered);
                slideEl = el.children[0];
            } else slideEl = rendered;
        } else if (swiper.isElement) slideEl = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('swiper-slide');
        else slideEl = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', String(index));
        if (!params.renderSlide) (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && (initialSlide ?? 0) > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = getParams();
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView ?? 1;
        const groupSize = slidesPerGroup ?? 1;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (groupSize - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : groupSize) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        const virtualParams = getParams();
        if (virtualParams.renderExternal) {
            const slidesToRender = [];
            for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
            virtualParams.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: slidesToRender
            });
            if (virtualParams.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $1a1b1b27ad713891$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (slides !== null && typeof slides === 'object' && 'length' in slides) {
            const arr = slides;
            for(let i = 0; i < arr.length; i += 1)if (arr[i]) swiper.virtual.slides.push(arr[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (getParams().cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[Number(cachedIndex)];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', String(parseInt(cachedElIndex, 10) + numberOfNewSlides));
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        const shiftCacheDownFrom = (removedIndex)=>{
            Object.keys(swiper.virtual.cache).forEach((key)=>{
                const numericKey = Number(key);
                if (numericKey > removedIndex) {
                    const shifted = swiper.virtual.cache[numericKey];
                    swiper.virtual.cache[numericKey - 1] = shifted;
                    shifted.setAttribute('data-swiper-slide-index', String(numericKey - 1));
                    delete swiper.virtual.cache[numericKey];
                }
            });
        };
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                shiftCacheDownFrom(slidesIndexes[i]);
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes];
                shiftCacheDownFrom(slidesIndexes);
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (getParams().cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!getParams().enabled) return;
        let domSlidesAssigned = false;
        const passedVirtual = swiper.passedParams.virtual;
        const passedSlidesUndefined = !passedVirtual || typeof passedVirtual !== 'object' || passedVirtual.slides === undefined;
        if (passedSlidesUndefined) {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', String(slideIndex));
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = getParams().slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!getParams().enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!getParams().enabled) return;
        if (swiper.params.cssMode) (0, $1a1b1b27ad713891$export$efccba1c4a2ef57b)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
};



const $0f5b87453c70066f$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function getParams() {
        return swiper.params.keyboard;
    }
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        const e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        const kc = e.keyCode || e.charCode;
        const params = getParams();
        const pageUpDown = !!params.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        const activeElement = document.activeElement;
        if (activeElement && (activeElement.isContentEditable || activeElement.nodeName && (activeElement.nodeName.toLowerCase() === 'input' || activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (params.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $1a1b1b27ad713891$export$35e795649ee09318)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $1a1b1b27ad713891$export$35e795649ee09318)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $1a1b1b27ad713891$export$dda1d9f60106f0e9)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue;
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        const speed = params.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.cancelable) e.preventDefault();
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.cancelable) e.preventDefault();
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    swiper.keyboard = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('init', ()=>{
        if (getParams().enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
};



const $55f4033a7228aeb5$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    let timeout;
    let lastScrollTime = (0, $1a1b1b27ad713891$export$90a7f3efeed30595)();
    let lastEventBeforeSnap;
    let mouseEntered = false;
    const recentWheelEvents = [];
    function getParams() {
        return swiper.params.mousewheel;
    }
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        const ev = e;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if (ev.detail !== undefined) sY = ev.detail;
        if (ev.wheelDelta !== undefined) sY = -ev.wheelDelta / 120;
        if (ev.wheelDeltaY !== undefined) sY = -ev.wheelDeltaY / 120;
        if (ev.wheelDeltaX !== undefined) sX = -ev.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if (ev.axis !== undefined && ev.HORIZONTAL_AXIS !== undefined && ev.axis === ev.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if (ev.deltaY !== undefined) pY = ev.deltaY;
        if (ev.deltaX !== undefined) pX = ev.deltaX;
        if (ev.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && ev.deltaMode) {
            if (ev.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        mouseEntered = false;
    }
    function animateSlider(newEvent) {
        const params = getParams();
        if (params.thresholdDelta && newEvent.delta < params.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (params.thresholdTime && (0, $1a1b1b27ad713891$export$90a7f3efeed30595)() - lastScrollTime < params.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $1a1b1b27ad713891$export$90a7f3efeed30595)() - lastScrollTime < 60) // Return false as a default
        return true;
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = getParams();
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event) {
        let e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        let disableParentSwiper = true;
        if (!swiper.enabled) return false;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        const params = getParams();
        if (event.target.closest(`.${params.noMousewheelClass}`)) return false;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        const freeModeParams = swiper.params.freeMode;
        if (!swiper.params.freeMode || !freeModeParams?.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $1a1b1b27ad713891$export$90a7f3efeed30595)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            const newEvent = {
                time: (0, $1a1b1b27ad713891$export$90a7f3efeed30595)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (freeModeParams?.sticky) {
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && firstEvent && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $1a1b1b27ad713891$export$3b14a55fb2447963)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) timeout = (0, $1a1b1b27ad713891$export$3b14a55fb2447963)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                const autoplayParams = swiper.params.autoplay;
                if (swiper.params.autoplay && autoplayParams?.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.cancelable) e.preventDefault();
        return false;
    }
    function events(method) {
        const params = getParams();
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener('wheel', handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        const params = getParams();
        if (!params.enabled && swiper.params.cssMode) disable();
        if (params.enabled) enable();
    });
    swiper.mousewheel = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
};



function $8b4c362f9a8bd6f2$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    const target = params ?? {};
    const original = originalParams ?? {};
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!target[key] && target.auto === true) {
            let element = (0, $1a1b1b27ad713891$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            target[key] = element;
            original[key] = element;
        }
    });
    return target;
}



const $498ba94c47362e2e$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0.28 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
const $498ba94c47362e2e$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    // Initialized as a partial; remaining methods (update, init, destroy,
    // enable, disable) attach after their definitions below.
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $498ba94c47362e2e$var$arrowSvg
    };
    function getParams() {
        return swiper.params.navigation;
    }
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        return res;
    }
    function toggleEl(el, disabled) {
        const params = getParams();
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        swiper.params.navigation = (0, $8b4c362f9a8bd6f2$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        const params = getParams();
        if (!(params.nextEl || params.prevEl)) return;
        const nextEl = getEl(params.nextEl);
        const prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        const nextEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nextEl);
        const prevEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(tempEl, $498ba94c47362e2e$var$arrowSvg);
                    const svgEl = tempEl.querySelector('svg');
                    if (svgEl) el.appendChild(svgEl);
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEls.forEach((el)=>initButton(el, 'next'));
        prevEls.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nextEl);
        const prevEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...params.disabledClass.split(' '));
        };
        nextEls.forEach((el)=>destroyButton(el, 'next'));
        prevEls.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nextEl);
        const prevEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEls,
            ...prevEls
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(params.lockClass));
    });
    on('click', (_s, e)=>{
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nextEl);
        const prevEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEls.includes(targetEl) || nextEls.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.composedPath ? e.composedPath() : [];
            if (path.length) targetIsButton = path.find((pathEl)=>nextEls.includes(pathEl) || prevEls.includes(pathEl));
        }
        if (params.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEls.length) isHidden = nextEls[0].classList.contains(params.hiddenClass);
            else if (prevEls.length) isHidden = prevEls[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEls,
                ...prevEls
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(params.hiddenClass));
        }
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(...params.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(...params.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
};


function $4caaf8b290da705c$export$db3b6bfb95261072(classes = '') {
    return `.${classes.trim().replace(/([.:!+/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1').replace(/ /g, '.')}`;
}




const $cb825807f506f721$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $cb825807f506f721$var$isFreeModeEnabled = (swiper)=>!!swiper.params.freeMode?.enabled;
// Slides count for bullets/fraction/progressbar totals: with grid rows the
// slides that share a column collapse into one snap position.
const $cb825807f506f721$var$getSlidesLength = (swiper)=>{
    if ($cb825807f506f721$var$isVirtualEnabled(swiper)) return swiper.virtual.slides.length;
    const gridRows = swiper.params.grid?.rows;
    if (swiper.grid && gridRows && gridRows > 1) return swiper.slides.length / Math.ceil(gridRows);
    return swiper.slides.length;
};
const $cb825807f506f721$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    // Initialized as a partial; remaining methods (render, update, init,
    // destroy, enable, disable) attach after their definitions below.
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function getParams() {
        return swiper.params.pagination;
    }
    function isPaginationDisabled() {
        const elParam = getParams().el;
        return !elParam || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = getParams();
        if (!bulletEl) return;
        let current = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (current) {
            current.classList.add(`${bulletActiveClass}-${position}`);
            current = current[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (current) current.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return undefined;
    }
    function onBulletClick(e) {
        const targetEl = e.target;
        const bulletEl = targetEl.closest((0, $4caaf8b290da705c$export$db3b6bfb95261072)(getParams().bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = ((0, $1a1b1b27ad713891$export$8b22cf2602fb60ce)(bulletEl) ?? 0) * (swiper.params.slidesPerGroup ?? 1);
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = getParams();
        if (isPaginationDisabled()) return;
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.pagination.el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = $cb825807f506f721$var$getSlidesLength(swiper);
        const total = swiper.params.loop ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1)) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = (swiper.params.slidesPerGroup ?? 1) > 1 ? Math.floor(swiper.realIndex / (swiper.params.slidesPerGroup ?? 1)) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex = 0;
            let lastIndex = 0;
            let midIndex = 0;
            if (params.dynamicBullets) {
                bulletSize = (0, $1a1b1b27ad713891$export$23f2a1d2818174ef)(bullets[0], swiper.isHorizontal() ? 'width' : 'height');
                const dim = swiper.isHorizontal() ? 'width' : 'height';
                els.forEach((subEl)=>{
                    subEl.style[dim] = `${(bulletSize ?? 0) * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    '',
                    '-next',
                    '-next-next',
                    '-prev',
                    '-prev-prev',
                    '-main'
                ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).flatMap((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : [
                        s
                    ]);
                bulletEl.classList.remove(...classesToRemove);
            });
            if (els.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $1a1b1b27ad713891$export$8b22cf2602fb60ce)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets && bulletIndex !== undefined) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = ((bulletSize ?? 0) * dynamicBulletsLength - (bulletSize ?? 0)) / 2 - midIndex * (bulletSize ?? 0);
                const offsetProp = rtl ? 'right' : 'left';
                const positionDim = swiper.isHorizontal() ? offsetProp : 'top';
                bullets.forEach((bullet)=>{
                    bullet.style[positionDim] = `${bulletsOffset}px`;
                });
            }
        }
        els.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $4caaf8b290da705c$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = String(params.formatFractionCurrent(current + 1));
                });
                subEl.querySelectorAll((0, $4caaf8b290da705c$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = String(params.formatFractionTotal(total));
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $4caaf8b290da705c$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = getParams();
        if (isPaginationDisabled()) return;
        const slidesLength = $cb825807f506f721$var$getSlidesLength(swiper);
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.pagination.el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1)) : swiper.snapGrid.length;
            if (swiper.params.freeMode && $cb825807f506f721$var$isFreeModeEnabled(swiper) && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // oxfmt-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        els.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...Array.from(subEl.querySelectorAll((0, $4caaf8b290da705c$export$db3b6bfb95261072)(params.bulletClass))));
        });
        if (params.type !== 'custom') emit('paginationRender', els[0]);
    }
    function init() {
        swiper.params.pagination = (0, $8b4c362f9a8bd6f2$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = getParams();
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || Array.isArray(el) && el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) {
                const found = el.find((subEl)=>{
                    if ((0, $1a1b1b27ad713891$export$35e795649ee09318)(subEl, '.swiper')[0] !== swiper.el) return false;
                    return true;
                });
                if (found) el = found;
            }
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = getParams();
        if (isPaginationDisabled()) return;
        const el = swiper.pagination.el;
        if (el) {
            const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
            els.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = getParams();
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.pagination.el);
        els.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.pagination;
        if (el) {
            const params = getParams();
            const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
            els.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](params.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.pagination.el);
        const params = getParams();
        if (params.el && params.hideOnClick && els && els.length > 0 && !targetEl.classList.contains(params.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = els[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            els.forEach((subEl)=>subEl.classList.toggle(params.hiddenClass));
        }
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(params.paginationDisabledClass);
        const { el: el } = swiper.pagination;
        if (el) {
            const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
            els.forEach((subEl)=>subEl.classList.remove(params.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(params.paginationDisabledClass);
        const { el: el } = swiper.pagination;
        if (el) {
            const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
            els.forEach((subEl)=>subEl.classList.add(params.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
};





const $9c312e494b5c6d05$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos = 0;
    let dragSize = 0;
    let trackSize = 0;
    let divider = 0;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    // Initialized as a partial; remaining methods (updateSize, setTranslate,
    // init, destroy, enable, disable) attach after their definitions below.
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function getParams() {
        return swiper.params.scrollbar;
    }
    // Positions the drag element from the current progress and track/drag sizes.
    function updateDragPosition() {
        const { rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl } = swiper.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop ?? 0 : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
    }
    function setTranslate() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        const { el: el } = swiper.scrollbar;
        updateDragPosition();
        if (params.hide) {
            if (timeout) clearTimeout(timeout);
            el.style.opacity = '1';
            timeout = setTimeout(()=>{
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!getParams().el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + (swiper.params.slidesOffsetBefore ?? 0) - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (params.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(String(params.dragSize), 10);
        // Size and position the drag for the new sizes without the show/hide side effects of setTranslate().
        updateDragPosition();
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (params.hide) el.style.opacity = '0';
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.clientX ?? e.touches?.[0]?.clientX ?? 0;
        return e.clientY ?? e.touches?.[0]?.clientY ?? 0;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $1a1b1b27ad713891$export$dda1d9f60106f0e9)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = getParams();
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        if (dragTimeout) clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = '1';
        if (swiper.params.cssMode) swiper.wrapperEl.style.scrollSnapType = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.cancelable) e.preventDefault();
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = getParams();
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.scrollSnapType = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            if (dragTimeout) clearTimeout(dragTimeout);
            dragTimeout = (0, $1a1b1b27ad713891$export$3b14a55fb2447963)(()=>{
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        el[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $8b4c362f9a8bd6f2$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = getParams();
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        const elTyped = el;
        elTyped.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl = null;
        if (elTyped) {
            dragEl = elTyped.querySelector((0, $4caaf8b290da705c$export$db3b6bfb95261072)(params.dragClass));
            if (!dragEl) {
                dragEl = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', params.dragClass);
                elTyped.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: elTyped,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (elTyped) elTyped.classList[swiper.enabled ? 'remove' : 'add'](...(0, $1a1b1b27ad713891$export$db3b6bfb95261072)(params.lockClass));
    }
    function destroy() {
        const params = getParams();
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $1a1b1b27ad713891$export$db3b6bfb95261072)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = getParams();
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.scrollbar.el);
        els.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $1a1b1b27ad713891$export$db3b6bfb95261072)(getParams().lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(...(0, $1a1b1b27ad713891$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $1a1b1b27ad713891$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(...(0, $1a1b1b27ad713891$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $1a1b1b27ad713891$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
};



const $0f12e038cea0b22c$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        parallax: {
            enabled: false
        }
    });
    function getParams() {
        return swiper.params.parallax;
    }
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${Number(x) * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${Number(y) * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const opacityNum = Number(opacity);
            const currentOpacity = opacityNum - (opacityNum - 1) * (1 - Math.abs(progress));
            el.style.opacity = String(currentOpacity);
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const scaleNum = Number(scale);
            const currentScale = scaleNum - (scaleNum - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = Number(rotate) * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        const elements = (0, $1a1b1b27ad713891$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $1a1b1b27ad713891$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress ?? 0;
            const slidesPerGroup = swiper.params.slidesPerGroup ?? 1;
            if (slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed ?? 300)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            const attr = parallaxEl.getAttribute('data-swiper-parallax-duration');
            let parallaxDuration = (attr ? parseInt(attr, 10) : 0) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!getParams().enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!getParams().enabled) return;
        setTransition(duration);
    });
};



const $50485fd3c3977f83$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    function getParams() {
        return swiper.params.zoom;
    }
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched = false;
    let fakeGestureMoved = false;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = getParams();
        const attr = gesture.imageWrapEl?.getAttribute('data-swiper-zoom');
        const maxRatio = attr != null ? Number(attr) : params.maxRatio;
        const imageEl = gesture.imageEl;
        if (params.limitToOriginalSize && imageEl && imageEl.naturalWidth) {
            const imageMaxRatio = imageEl.naturalWidth / imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2 || !gesture.imageEl) return [
            null,
            null
        ];
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        const target = e.target;
        if (!target) return false;
        if (target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${getParams().containerClass}`;
        const target = e.target;
        if (!target) return false;
        if (target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = getParams();
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            const target = e.target;
            gesture.slideEl = target?.closest(`.${swiper.params.slideClass}, swiper-slide`) ?? undefined;
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $1a1b1b27ad713891$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX ?? 0;
            gesture.originY = originY ?? 0;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / (gesture.scaleStart ?? 1) * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        if (allowTouchMoveTimeout !== undefined) clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (image.isTouched) return;
        // Record the position before the imageEl guard, it is unset until the first pinch or zoom
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
        if (!gesture.imageEl) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && getParams().panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $1a1b1b27ad713891$export$9e5f44173e64f162)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $1a1b1b27ad713891$export$9e5f44173e64f162)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - (image.touchesStart.x ?? 0)), Math.abs(image.touchesCurrent.y - (image.touchesStart.y ?? 0)));
        if (touchesDiff > 5) swiper.allowClick = false;
        const startX = image.startX ?? 0;
        const startY = image.startY ?? 0;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(startX) && image.touchesCurrent.x < (image.touchesStart.x ?? 0) || Math.floor(image.maxX) === Math.floor(startX) && image.touchesCurrent.x > (image.touchesStart.x ?? 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(startY) && image.touchesCurrent.y < (image.touchesStart.y ?? 0) || Math.floor(image.maxY) === Math.floor(startY) && image.touchesCurrent.y > (image.touchesStart.y ?? 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - getParams().minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - (image.touchesStart.x ?? 0) + startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - (image.touchesStart.y ?? 0) + startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const velocityX = velocity.x ?? 0;
        const velocityY = velocity.y ?? 0;
        const momentumDistanceX = velocityX * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocityY * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocityX !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocityX);
        if (velocityY !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocityY);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${getParams().zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            if (e && typeof e !== 'number' && 'target' in e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`) ?? undefined;
            if (!gesture.slideEl) {
                const virtual = swiper.params.virtual;
                if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (0, $1a1b1b27ad713891$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $1a1b1b27ad713891$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        const eventIsPointer = e && typeof e !== 'number';
        if (typeof image.touchesStart.x === 'undefined' && eventIsPointer) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $1a1b1b27ad713891$export$dda1d9f60106f0e9)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $1a1b1b27ad713891$export$dda1d9f60106f0e9)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - (touchX ?? 0);
            diffY = offsetY + slideHeight / 2 - (touchY ?? 0);
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            const virtual = swiper.params.virtual;
            if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (0, $1a1b1b27ad713891$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $1a1b1b27ad713891$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (params.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (getParams().enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', ()=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && getParams().enabled && swiper.zoom.enabled && getParams().toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && getParams().enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && getParams().enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
};



class $48cba8351a6a90db$var$LinearSpline {
    x;
    y;
    lastIndex;
    binarySearch;
    constructor(x, y){
        let maxIndex;
        let minIndex;
        let guess;
        this.binarySearch = (array, val)=>{
            minIndex = -1;
            maxIndex = array.length;
            while(maxIndex - minIndex > 1){
                guess = maxIndex + minIndex >> 1;
                if (array[guess] <= val) minIndex = guess;
                else maxIndex = guess;
            }
            return maxIndex;
        };
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
    }
    interpolate(x2) {
        if (!x2) return 0;
        const i3 = this.binarySearch(this.x, x2);
        const i1 = i3 - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    }
}
const $48cba8351a6a90db$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function getParams() {
        return swiper.params.controller;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new $48cba8351a6a90db$var$LinearSpline(swiper.slidesGrid, c.slidesGrid) : new $48cba8351a6a90db$var$LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const SwiperCtor = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            const controllerParams = getParams();
            if (controllerParams.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            } else controlledTranslate = 0;
            if (!controlledTranslate || controllerParams.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (controllerParams.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) for(let i = 0; i < controlled.length; i += 1){
            const target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTranslate(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const SwiperCtor = swiper.constructor;
        const controlled = swiper.controller.control;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $1a1b1b27ad713891$export$3b14a55fb2447963)(()=>{
                    c.updateAutoHeight();
                });
                (0, $1a1b1b27ad713891$export$953cecd6e717a553)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) for(let i = 0; i < controlled.length; i += 1){
            const target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTransition(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        const controllerParam = getParams().control;
        if (typeof window !== 'undefined' && (typeof controllerParam === 'string' || (0, $1a1b1b27ad713891$export$43caf9889c228507)(controllerParam))) {
            const controlElements = typeof controllerParam === 'string' ? [
                ...document.querySelectorAll(controllerParam)
            ] : [
                controllerParam
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                const list = swiper.controller.control;
                if (controlElement && controlElement.swiper) list.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        const detail = e.detail;
                        if (detail && detail[0]) list.push(detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        // After this point control is either Swiper or Swiper[] (or null/undefined),
        // never the string/HTMLElement forms that the public option accepts.
        swiper.controller.control = controllerParam;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    // Event payloads come typed against the legacy public Swiper class
    // (src/types/swiper-class.d.ts) until Phase 5 deletes src/types/; cast the
    // forwarded byController back to the core Swiper so it lines up with the
    // controller-internal signatures.
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
};




const $f6da9fdf1fb51fd0$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $f6da9fdf1fb51fd0$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler = false;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function getParams() {
        return swiper.params.a11y;
    }
    function notify(message) {
        const notification = liveRegion;
        if (!notification || !message) return;
        (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElLabel(el, label) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', 'true');
        });
    }
    function enableEl(el) {
        const els = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(el);
        els.forEach((subEl)=>{
            subEl.removeAttribute('aria-disabled');
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = getParams();
        const paginationParams = swiper.params.pagination;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(targetEl))) {
            if (!targetEl.matches((0, $4caaf8b290da705c$export$db3b6bfb95261072)(paginationParams?.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.navigation.prevEl);
            const nextEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $4caaf8b290da705c$export$db3b6bfb95261072)(paginationParams?.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return !!(swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length);
    }
    function hasClickablePagination() {
        const paginationParams = swiper.params.pagination;
        return hasPagination() && !!paginationParams?.clickable;
    }
    function updatePagination() {
        const params = getParams();
        if (!hasPagination()) return;
        const paginationParams = swiper.params.pagination;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (paginationParams.clickable) {
                makeElFocusable(bulletEl);
                if (!paginationParams.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, String(((0, $1a1b1b27ad713891$export$8b22cf2602fb60ce)(bulletEl) ?? 0) + 1)));
                }
            }
            if (bulletEl.matches((0, $4caaf8b290da705c$export$db3b6bfb95261072)(paginationParams.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, _wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (_e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    // Loop keyboard trap (#8181): on Tab out of the last/first real slide, make other slides `inert` for the keypress so focus leaves the wrapper
    let inertSlides = [];
    const releaseInertSlides = ()=>{
        inertSlides.forEach((slideEl)=>slideEl.removeAttribute('inert'));
        inertSlides = [];
    };
    const handleTabKey = (e)=>{
        if (e.key !== 'Tab' || !swiper.params.loop || swiper.destroyed) return;
        const target = e.target;
        const slideEl = target?.closest?.(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const realIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index') || '', 10);
        if (Number.isNaN(realIndex)) return;
        const slidesLength = $f6da9fdf1fb51fd0$var$isVirtualEnabled(swiper) ? swiper.virtual.slides.length : swiper.slides.length;
        const isEdge = e.shiftKey ? realIndex === 0 : realIndex === slidesLength - 1;
        if (!isEdge) return;
        releaseInertSlides();
        swiper.slides.forEach((el)=>{
            if (el === slideEl || el.hasAttribute('inert')) return;
            el.setAttribute('inert', '');
            inertSlides.push(el);
        });
        setTimeout(releaseInertSlides, 0);
    };
    const handleFocus = (e)=>{
        const params = getParams();
        if (swiper.a11y.clicked || !params.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const target = e.target;
        const slideEl = target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isVirtual = $f6da9fdf1fb51fd0$var$isVirtualEnabled(swiper);
        const isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        const sourceCapabilities = e.sourceCapabilities;
        if (sourceCapabilities && sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = getParams();
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        const slideLabelMessage = params.slideLabelMessage;
        if (slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : index;
            const ariaLabelMessage = slideLabelMessage.replace(/\{\{index\}\}/, String(slideIndex + 1)).replace(/\{\{slidesLength\}\}/, String(slidesLength));
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = getParams();
        if (liveRegion) swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = String(params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`);
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const autoplayParams = swiper.params.autoplay;
            const live = swiper.params.autoplay && autoplayParams?.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        const nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        const nextEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nav.nextEl);
        const prevEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nav.prevEl);
        if (nextEls) nextEls.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEls) prevEls.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('keydown', handleTabKey, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        const nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        const nextEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nav.nextEl);
        const prevEls = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(nav.prevEl);
        if (nextEls) nextEls.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEls) prevEls.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $1a1b1b27ad713891$export$625550452a3fa3ec)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('keydown', handleTabKey, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
        releaseInertSlides();
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('span', getParams().notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!getParams().enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!getParams().enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!getParams().enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!getParams().enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!getParams().enabled) return;
        destroy();
    });
};


const $b8d33cd9356c0a8b$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {
        key: undefined,
        value: undefined
    };
    function getParams() {
        return swiper.params.history;
    }
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const params = getParams();
        if (!initialized || !params.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const isVirtualEnabled = !!swiper.params.virtual?.enabled;
        const slide = swiper.virtual && isVirtualEnabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        if (!slide) return;
        let value = slugify(slide.getAttribute('data-history') || '');
        const root = params.root;
        if (root.length > 0) {
            const trimmedRoot = root[root.length - 1] === '/' ? root.slice(0, root.length - 1) : root;
            value = `${trimmedRoot}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key || '')) value = `${key ? `${key}/` : ''}${value}`;
        if (params.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (params.replaceState) window.history.replaceState({
            value: value
        }, '', value);
        else window.history.pushState({
            value: value
        }, '', value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history') || '');
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const params = swiper.params.history;
        if (!params) return;
        if (!window.history || !window.history.pushState) {
            params.enabled = false;
            const hashParams = swiper.params.hashNavigation;
            if (hashParams) hashParams.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        if (!getParams().replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (getParams().enabled) init();
    });
    on('destroy', ()=>{
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(getParams().key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(getParams().key, swiper.activeIndex);
    });
};



const $a836bb54558b9c4a$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $a836bb54558b9c4a$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, emit: emit, on: on })=>{
    let initialized = false;
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if ($a836bb54558b9c4a$var$isVirtualEnabled(swiper)) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index') || '0', 10);
                    return index;
                }
                const matched = (0, $1a1b1b27ad713891$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0];
                return matched ? swiper.getSlideIndex(matched) : 0;
            }
        }
    });
    function getParams() {
        return swiper.params.hashNavigation;
    }
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = $a836bb54558b9c4a$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = getParams().getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        const params = getParams();
        if (!initialized || !params.enabled) return;
        const activeSlideEl = $a836bb54558b9c4a$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (params.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, '', `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        const params = getParams();
        const historyParams = swiper.params.history;
        if (!params.enabled || historyParams && historyParams.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = params.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (params.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (getParams().watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (getParams().enabled) init();
    });
    on('destroy', ()=>{
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
};


const $af2f603355919797$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params })=>{
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function getParams() {
        return swiper.params.autoplay;
    }
    // params here is the user-supplied passedParams; extendParams hasn't yet
    // merged the defaults into swiper.params.autoplay at this point.
    const initialAutoplayDelay = typeof params.autoplay === 'object' && params.autoplay && typeof params.autoplay.delay === 'number' ? params.autoplay.delay : 3000;
    let timeout;
    let raf;
    let autoplayDelayTotal = initialAutoplayDelay;
    let autoplayDelayCurrent = initialAutoplayDelay;
    let autoplayTimeLeft = 0;
    let autoplayStartTime = new Date().getTime();
    let wasPaused = false;
    let isTouched = false;
    let pausedByTouch = false;
    let touchStartTimeout;
    let pausedByInteraction = false;
    let pausedByPointerEnter = false;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        const detail = e.detail;
        if (pausedByPointerEnter || detail && detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        const virtualEnabled = !!swiper.params.virtual?.enabled;
        if (swiper.virtual && virtualEnabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const attr = activeSlideEl.getAttribute('data-swiper-autoplay');
        if (attr == null) return undefined;
        return parseInt(attr, 10);
    };
    const getTotalDelay = ()=>{
        let totalDelay = getParams().delay;
        const currentSlideDelay = getSlideDelay();
        if (typeof currentSlideDelay === 'number' && !Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return 0;
        if (raf !== undefined) cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            const autoplayParams = getParams();
            if (autoplayParams.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            if (timeout !== undefined) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        return delay;
    };
    const start = ()=>{
        if (swiper.destroyed) return false;
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
        return true;
    };
    const stop = ()=>{
        if (swiper.destroyed) return false;
        swiper.autoplay.running = false;
        if (timeout !== undefined) clearTimeout(timeout);
        if (raf !== undefined) cancelAnimationFrame(raf);
        emit('autoplayStop');
        return true;
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (timeout !== undefined) clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (getParams().waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || getParams().delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (getParams().pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (getParams().enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, _speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (getParams().disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        if (touchStartTimeout !== undefined) clearTimeout(touchStartTimeout);
        if (timeout !== undefined) clearTimeout(timeout);
        if (getParams().disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
};



const $2dce6cb97c1cf323$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function getParams() {
        return swiper.params.thumbs;
    }
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        const virtual = thumbsSwiper.params.virtual;
        return !!virtual && !!virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        const thumbsParams = getParams();
        if (clickedSlide && clickedSlide.classList.contains(thumbsParams.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) {
            const attr = thumbsSwiper.clickedSlide?.getAttribute('data-swiper-slide-index');
            slideToIndex = attr == null ? clickedIndex : parseInt(attr, 10);
        } else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const thumbsParams = getParams();
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            const thumbsSwiper = thumbsParams.swiper;
            swiper.thumbs.swiper = thumbsSwiper;
            Object.assign(thumbsSwiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(thumbsSwiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            thumbsSwiper.update();
        } else if ((0, $1a1b1b27ad713891$export$2408f22a0fab9ae5)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return false;
        thumbsSwiper.el.classList.add(thumbsParams.thumbsContainerClass);
        thumbsSwiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) thumbsSwiper.on('virtualUpdate', ()=>{
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbsParams = getParams();
        const thumbActiveClass = thumbsParams.slideThumbActiveClass;
        const slidesPerView = swiper.params.slidesPerView;
        if (typeof slidesPerView === 'number' && slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = slidesPerView;
        if (!thumbsParams.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(let i = 0; i < thumbsToActivate; i += 1)(0, $1a1b1b27ad713891$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else for(let i = 0; i < thumbsToActivate; i += 1){
            const slide = thumbsSwiper.slides[swiper.realIndex + i];
            if (slide) slide.classList.add(thumbActiveClass);
        }
        if (p?.autoScroll ?? true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const thumbsSlidesPerView = thumbsSwiper.params.slidesPerView;
        const slidesPerView = thumbsSlidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSlidesPerView ?? 1;
        const autoScrollOffset = getParams().autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = newThumbsSlide ? thumbsSwiper.slides.indexOf(newThumbsSlide) : -1;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                // previousIndex is a DOM index that loopFix shifts when main swiper is looped
                direction = newThumbsIndex > (swiper.previousRealIndex ?? 0) ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', ()=>{
        const thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || (0, $1a1b1b27ad713891$export$43caf9889c228507)(thumbs.swiper)) {
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        const detail = e.detail;
                        thumbs.swiper = detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
};



const $90e0af84561b2482$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, emit: emit, once: once })=>{
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function getParams() {
        return swiper.params.freeMode;
    }
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime ?? (0, $1a1b1b27ad713891$export$90a7f3efeed30595)()
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $1a1b1b27ad713891$export$90a7f3efeed30595)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        const params = swiper.params;
        const freeModeParams = getParams();
        // Time diff
        const touchEndTime = (0, $1a1b1b27ad713891$export$90a7f3efeed30595)();
        const timeDiff = touchEndTime - (data.touchStartTime ?? touchEndTime);
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (freeModeParams.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < freeModeParams.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $1a1b1b27ad713891$export$90a7f3efeed30595)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= freeModeParams.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * freeModeParams.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * freeModeParams.momentumBounceRatio;
            let needsLoopFix = false;
            if (newPosition < swiper.maxTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (freeModeParams.sticky) {
                let nextSlide = 0;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs((snapGrid[nextSlide - 1] ?? snapGrid[nextSlide]) - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (freeModeParams.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    const speed = params.speed;
                    if (moveDistance < currentSlideSize) momentumDuration = speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = speed * 1.5;
                    else momentumDuration = speed * 2.5;
                }
            } else if (freeModeParams.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (freeModeParams.momentumBounce && doBounce && afterBouncePosition !== undefined) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $1a1b1b27ad713891$export$953cecd6e717a553)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $1a1b1b27ad713891$export$953cecd6e717a553)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $1a1b1b27ad713891$export$953cecd6e717a553)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (freeModeParams.sticky) {
            swiper.slideToClosest();
            return;
        } else emit('_freeModeNoMomentumRelease');
        if (!freeModeParams.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    swiper.freeMode = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
};


const $828fe0781214763c$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    function getParams() {
        return swiper.params.grid;
    }
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween ?? 0;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const isVirtualEnabled = ()=>{
        const virtualParams = swiper.params.virtual;
        return !!swiper.virtual && typeof virtualParams === 'object' && virtualParams !== null && !!virtualParams.enabled;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, Math.floor(slidesPerView ?? 1) * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            const gridSlide = slide;
            if (gridSlide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style.setProperty(swiper.getDirectionLabel('margin-top'), '');
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && (slidesPerGroup ?? 1) > 1) {
            const groupsPer = slidesPerGroup ?? 1;
            const groupIndex = Math.floor(i / (groupsPer * rows));
            const slideIndexInGroup = i - rows * groupsPer * groupIndex;
            const columnsInGroup = groupIndex === 0 ? groupsPer : Math.min(Math.ceil((slidesLength - groupIndex * rows * groupsPer) / rows), groupsPer);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * groupsPer;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = String(newSlideOrderIndex);
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        const gridSlide = slide;
        gridSlide.row = row;
        gridSlide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style.setProperty(swiper.getDirectionLabel('margin-top'), row !== 0 && spaceBetween ? `${spaceBetween}px` : '');
        gridSlide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = getParams();
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style.setProperty(swiper.getDirectionLabel('width'), `${swiper.virtualSize + spaceBetween}px`);
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        const gridParams = swiper.params.grid;
        wasMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const gridParams = params.grid;
        const isMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (gridParams.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
};



function $89e3e074ce210d2d$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        if (!currentSlide) continue;
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (Array.isArray(slides)) {
        for(let i = 0; i < slides.length; i += 1){
            const slide = slides[i];
            if (slide) slidesEl.append(slide);
        }
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $89e3e074ce210d2d$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child) slidesEl.append(child);
            (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (Array.isArray(slides)) for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        if (slide) appendElement(slide);
    }
    else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $89e3e074ce210d2d$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child) slidesEl.prepend(child);
            (0, $1a1b1b27ad713891$export$d141bba7fdc215a3)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (Array.isArray(slides)) {
        for(let i = 0; i < slides.length; i += 1){
            const slide = slides[i];
            if (slide) prependElement(slide);
        }
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $89e3e074ce210d2d$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $89e3e074ce210d2d$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    if (Array.isArray(slidesIndexes)) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            const indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        const indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
const $89e3e074ce210d2d$export$2e2bcd8739ae039 = ({ swiper: swiper })=>{
    Object.assign(swiper, {
        appendSlide: $89e3e074ce210d2d$var$appendSlide.bind(swiper),
        prependSlide: $89e3e074ce210d2d$var$prependSlide.bind(swiper),
        addSlide: $89e3e074ce210d2d$var$addSlide.bind(swiper),
        removeSlide: $89e3e074ce210d2d$var$removeSlide.bind(swiper),
        removeAllSlides: $89e3e074ce210d2d$var$removeAllSlides.bind(swiper)
    });
};


function $9db384575b11f52e$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            const effectParams = getEffectParams ? getEffectParams() : undefined;
            if (!effectParams || !effectParams.slideShadows) return;
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual = false;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $a695b1856bc38173$export$f1e1789686576879(_effectParams, slideEl) {
    const transformEl = (0, $1a1b1b27ad713891$export$ffb5f4729a158638)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style.setProperty('-webkit-backface-visibility', 'hidden');
    }
    return transformEl;
}



function $6e82293aab0cac86$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) // assume shadow root
        return swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
        if ((0, $1a1b1b27ad713891$export$43caf9889c228507)(el.parentElement)) return el.parentElement;
        return undefined;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return !!el && swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $1a1b1b27ad713891$export$953cecd6e717a553)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



const $f38d9eec327ae2fd$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        fadeEffect: {
            crossFade: false,
            mode: 'default'
        }
    });
    // duration of the pending `out-in` transition, passed from setTransition to
    // setTranslate where the incoming slide is known
    let outInDuration = 0;
    function getParams() {
        return swiper.params.fadeEffect;
    }
    function getMode() {
        const params = getParams();
        if (params.mode === 'default' && params.crossFade) return 'cross-fade';
        return params.mode;
    }
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = getParams();
        const mode = getMode();
        const outInTransition = mode === 'out-in' && outInDuration > 0;
        const duration = outInDuration;
        outInDuration = 0;
        const targetEls = [];
        const incomingEls = [];
        let hasFadingOut = false;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const offset = slideEl.swiperSlideOffset ?? 0;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideProgress = slideEl.progress ?? 0;
            let slideOpacity;
            if (mode === 'cross-fade') slideOpacity = Math.max(1 - Math.abs(slideProgress), 0);
            else if (mode === 'out-in') slideOpacity = Math.max(1 - 2 * Math.abs(slideProgress), 0);
            else slideOpacity = 1 + Math.min(Math.max(slideProgress, -1), 0);
            const targetEl = (0, $a695b1856bc38173$export$f1e1789686576879)(params, slideEl);
            if (outInTransition) {
                const prevOpacity = parseFloat(targetEl.style.opacity);
                if (slideOpacity === 0 && prevOpacity > 0) hasFadingOut = true;
                if (slideOpacity > 0) incomingEls.push(targetEl);
                targetEls.push(targetEl);
            }
            targetEl.style.opacity = String(slideOpacity);
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
        if (outInTransition) {
            targetEls.forEach((el)=>{
                const delayed = hasFadingOut && incomingEls.includes(el);
                el.style.transitionDuration = `${duration / 2}ms`;
                el.style.transitionDelay = delayed ? `${duration / 2}ms` : '0ms';
            });
            (0, $6e82293aab0cac86$export$f1e1789686576879)({
                swiper: swiper,
                duration: duration,
                transformElements: incomingEls,
                allSlides: true
            });
        }
    };
    const setTransition = (duration)=>{
        const mode = getMode();
        const transformElements = swiper.slides.map((slideEl)=>(0, $1a1b1b27ad713891$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            if (mode === 'out-in' && duration === 0) el.style.transitionDelay = '';
        });
        if (mode === 'out-in' && duration > 0 && !swiper.params.cssMode) {
            // sequencing (half durations, delay on the incoming slide) and the
            // transitionend listener are set in setTranslate, which runs right after
            // with up-to-date slides progress. Attaching transitionend here to all
            // slides would end the transition when outgoing slides finish at half time
            outInDuration = duration;
            return;
        }
        (0, $6e82293aab0cac86$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $9db384575b11f52e$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};




const $df9201df1f0d6cac$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    function getParams() {
        return swiper.params.cubeEffect;
    }
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize } = swiper;
        const r = (0, $1a1b1b27ad713891$export$ae1af26003f05816)(swiper);
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = !!(swiper.virtual && swiper.params.virtual?.enabled);
        let wrapperRotate = 0;
        let cubeShadowEl = null;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index') ?? '0', 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style.setProperty('-webkit-transform-origin', `50% 50% -${swiperSize / 2}px`);
        if (params.shadow && cubeShadowEl) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        wrapperEl.style.transform = `translate3d(0px,0,0px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', '0px');
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect?.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $9db384575b11f52e$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
};



function $0398cb45eb1aca7e$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $1a1b1b27ad713891$export$ffb5f4729a158638)(slideEl);
    const selector = `.${shadowClass.split(' ').join('.')}`;
    const existing = shadowContainer.querySelector(selector);
    if (existing) return existing;
    const created = (0, $1a1b1b27ad713891$export$407448d2b89b1813)('div', shadowClass.split(' '));
    shadowContainer.append(created);
    return created;
}






const $7f72aebd5561104f$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    function getParams() {
        return swiper.params.flipEffect;
    }
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $0398cb45eb1aca7e$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $0398cb45eb1aca7e$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = getParams();
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const rotateFix = (0, $1a1b1b27ad713891$export$ae1af26003f05816)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            const offset = slideEl.swiperSlideOffset ?? 0;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = String(-Math.abs(Math.round(progress)) + slides.length);
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $a695b1856bc38173$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $1a1b1b27ad713891$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $6e82293aab0cac86$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $9db384575b11f52e$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};






const $937f0a98f71cf955$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    function getParams() {
        return swiper.params.coverflowEffect;
    }
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $1a1b1b27ad713891$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset ?? 0;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = typeof params.stretch === 'string' && params.stretch.indexOf('%') !== -1 ? parseFloat(params.stretch) / 100 * slideSize : params.stretch;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $a695b1856bc38173$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = String(-Math.abs(Math.round(offsetMultiplier)) + 1);
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $0398cb45eb1aca7e$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $0398cb45eb1aca7e$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = String(offsetMultiplier > 0 ? offsetMultiplier : 0);
                if (shadowAfterEl) shadowAfterEl.style.opacity = String(-offsetMultiplier > 0 ? -offsetMultiplier : 0);
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $1a1b1b27ad713891$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $9db384575b11f52e$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
};







const $d65c832468516f52$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    function getParams() {
        return swiper.params.creativeEffect;
    }
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = getParams();
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $1a1b1b27ad713891$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - (swiper.params.slidesOffsetBefore ?? 0);
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress ?? 0, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset ?? 0;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((_value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $0398cb45eb1aca7e$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = String(Math.min(Math.max(Math.abs(shadowOpacity), 0), 1));
                }
            }
            const targetEl = (0, $a695b1856bc38173$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = String(opacityString);
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $1a1b1b27ad713891$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $6e82293aab0cac86$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $9db384575b11f52e$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>getParams().perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};







const $6a43aa93759360a0$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    function getParams() {
        return swiper.params.cardsEffect;
    }
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset ?? 0;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset ?? 0;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual?.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && (currentTranslate ?? 0) < (startTranslate ?? 0);
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && (currentTranslate ?? 0) > (startTranslate ?? 0);
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            // wrap the value in parentheses instead of prepending `-` to the string,
            // as a negative tXAdd would otherwise produce an invalid `--` in calc()
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${-tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $0398cb45eb1aca7e$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = String(Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1));
            }
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const targetEl = (0, $a695b1856bc38173$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $1a1b1b27ad713891$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $6e82293aab0cac86$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $9db384575b11f52e$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: getParams().rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};




const $3c70f802c91490c5$var$initHeroSwiper = ()=>{
    const containers = document.querySelectorAll('.js-hero');
    if (!containers) return;
    containers.forEach((container)=>{
        new (0, $43dd4af6d8c862b5$export$25ce5a424b770e84)(container, {
            modules: [
                (0, $af2f603355919797$export$2e2bcd8739ae039),
                (0, $cb825807f506f721$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            pagination: {
                el: container.querySelector('.swiper-pagination')
            },
            breakpoints: {
                640: {
                    slidesPerView: 1
                },
                1024: {
                    slidesPerView: 1
                }
            }
        });
    });
};
const $3c70f802c91490c5$var$initUspsSwiper = ()=>{
    const containers = document.querySelectorAll('.js-usps');
    if (!containers) return;
    containers.forEach((container)=>{
        new (0, $43dd4af6d8c862b5$export$25ce5a424b770e84)(container, {
            slidesPerView: 1,
            loop: true,
            modules: [
                (0, $af2f603355919797$export$2e2bcd8739ae039)
            ],
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            breakpoints: {
                640: {
                    slidesPerView: 1
                },
                1024: {
                    slidesPerView: 4
                }
            }
        });
    });
};
const $3c70f802c91490c5$var$initProductSwiper = ()=>{
    const containers = document.querySelectorAll('.js-products');
    if (!containers) return;
    containers.forEach((container)=>{
        new (0, $43dd4af6d8c862b5$export$25ce5a424b770e84)(container, {
            slidesPerView: 1,
            spaceBetween: 20,
            watchSlidesProgress: true,
            watchOverflow: true,
            modules: [
                (0, $cb825807f506f721$export$2e2bcd8739ae039),
                (0, $498ba94c47362e2e$export$2e2bcd8739ae039)
            ],
            loop: true,
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true
            },
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.5
                },
                640: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 4
                }
            }
        });
    });
};
const $3c70f802c91490c5$var$initReviewSwiper = ()=>{
    const containers = document.querySelectorAll('.js-reviews-slider');
    if (!containers) return;
    containers.forEach((container)=>{
        new (0, $43dd4af6d8c862b5$export$25ce5a424b770e84)(container, {
            slidesPerView: 1,
            spaceBetween: 0,
            modules: [
                (0, $cb825807f506f721$export$2e2bcd8739ae039)
            ],
            pagination: {
                el: container.querySelector('.swiper-pagination')
            }
        });
    });
};
var $3c70f802c91490c5$export$2e2bcd8739ae039 = ()=>{
    $3c70f802c91490c5$var$initHeroSwiper();
    $3c70f802c91490c5$var$initUspsSwiper();
    $3c70f802c91490c5$var$initProductSwiper();
    $3c70f802c91490c5$var$initReviewSwiper();
};


var $40363820c3e434e5$export$2e2bcd8739ae039 = ()=>{
    const getEls = ()=>({
            consumer: document.getElementById('billing_type_personal'),
            business: document.getElementById('billing_type_business'),
            company: document.getElementById('billing_company_field'),
            vat: document.getElementById('webreact-btw-number_field'),
            country: document.getElementById('billing_country')
        });
    const updateVisibility = ()=>{
        const { consumer: consumer, business: business, company: company, vat: vat, country: country } = getEls();
        if (!company || !vat) return;
        const isBusiness = !!business?.checked;
        const countryCode = (country?.value || '').toUpperCase();
        const isNL = countryCode === 'NL';
        company.style.display = isBusiness ? 'block' : 'none';
        vat.style.display = isBusiness && !isNL ? 'block' : 'none';
    };
    document.addEventListener('change', (e)=>{
        const t = e.target;
        if (!t) return;
        const id = t.id;
        if (id === 'billing_country' || id === 'billing_type_personal' || id === 'billing_type_business') updateVisibility();
    });
    const w = window;
    if (w?.jQuery) {
        const $ = w.jQuery;
        $(document.body).on('updated_checkout country_to_state_changed', updateVisibility);
        $(document).on('select2:select', '#billing_country', updateVisibility);
    }
    const mo = new MutationObserver(()=>updateVisibility());
    mo.observe(document.body, {
        childList: true,
        subtree: true
    });
    updateVisibility();
};


// packages/alpinejs/src/scheduler.js
var $b697b2a0f6242b3c$var$flushPending = false;
var $b697b2a0f6242b3c$var$flushing = false;
var $b697b2a0f6242b3c$var$queue = [];
var $b697b2a0f6242b3c$var$lastFlushedIndex = -1;
var $b697b2a0f6242b3c$var$queueNeedsSort = false;
var $b697b2a0f6242b3c$var$transactionActive = false;
function $b697b2a0f6242b3c$var$scheduler(callback) {
    $b697b2a0f6242b3c$var$queueJob(callback);
}
function $b697b2a0f6242b3c$var$startTransaction() {
    $b697b2a0f6242b3c$var$transactionActive = true;
}
function $b697b2a0f6242b3c$var$commitTransaction() {
    $b697b2a0f6242b3c$var$transactionActive = false;
    $b697b2a0f6242b3c$var$queueFlush();
}
function $b697b2a0f6242b3c$var$queueJob(job) {
    if (!$b697b2a0f6242b3c$var$queue.includes(job)) {
        $b697b2a0f6242b3c$var$queue.push(job);
        if (job._x_schedulerPriority !== void 0) $b697b2a0f6242b3c$var$queueNeedsSort = true;
    }
    $b697b2a0f6242b3c$var$queueFlush();
}
function $b697b2a0f6242b3c$var$dequeueJob(job) {
    let index = $b697b2a0f6242b3c$var$queue.indexOf(job);
    if (index !== -1 && index > $b697b2a0f6242b3c$var$lastFlushedIndex) $b697b2a0f6242b3c$var$queue.splice(index, 1);
}
function $b697b2a0f6242b3c$var$queueFlush() {
    if (!$b697b2a0f6242b3c$var$flushing && !$b697b2a0f6242b3c$var$flushPending) {
        if ($b697b2a0f6242b3c$var$transactionActive) return;
        $b697b2a0f6242b3c$var$flushPending = true;
        queueMicrotask($b697b2a0f6242b3c$var$flushJobs);
    }
}
function $b697b2a0f6242b3c$var$flushJobs() {
    $b697b2a0f6242b3c$var$flushPending = false;
    $b697b2a0f6242b3c$var$flushing = true;
    for(let i = 0; i < $b697b2a0f6242b3c$var$queue.length; i++){
        if ($b697b2a0f6242b3c$var$queueNeedsSort) $b697b2a0f6242b3c$var$sortPendingJobs(i);
        $b697b2a0f6242b3c$var$queue[i]();
        $b697b2a0f6242b3c$var$lastFlushedIndex = i;
    }
    $b697b2a0f6242b3c$var$queue.length = 0;
    $b697b2a0f6242b3c$var$lastFlushedIndex = -1;
    $b697b2a0f6242b3c$var$queueNeedsSort = false;
    $b697b2a0f6242b3c$var$flushing = false;
}
function $b697b2a0f6242b3c$var$sortPendingJobs(start2) {
    let depths = /* @__PURE__ */ new Map();
    let sorted = $b697b2a0f6242b3c$var$queue.slice(start2).sort((a, b)=>$b697b2a0f6242b3c$var$compareJobs(a, b, depths));
    for(let i = 0; i < sorted.length; i++)$b697b2a0f6242b3c$var$queue[start2 + i] = sorted[i];
    $b697b2a0f6242b3c$var$queueNeedsSort = false;
}
function $b697b2a0f6242b3c$var$compareJobs(a, b, depths) {
    if (!$b697b2a0f6242b3c$var$isStructural(a)) return $b697b2a0f6242b3c$var$isStructural(b) ? 1 : 0;
    if (!$b697b2a0f6242b3c$var$isStructural(b)) return -1;
    let depthDifference = $b697b2a0f6242b3c$var$getElementDepth(a._x_schedulerPriority.el, depths) - $b697b2a0f6242b3c$var$getElementDepth(b._x_schedulerPriority.el, depths);
    return depthDifference || a._x_schedulerPriority.order - b._x_schedulerPriority.order;
}
function $b697b2a0f6242b3c$var$isStructural(job) {
    return job._x_schedulerPriority !== void 0;
}
function $b697b2a0f6242b3c$var$getElementDepth(el, depths) {
    if (depths.has(el)) return depths.get(el);
    let depth = 0;
    let owner = el;
    while(el){
        depth++;
        if (el._x_teleportBack) el = el._x_teleportBack;
        else if (typeof ShadowRoot === "function" && el.parentNode instanceof ShadowRoot) el = el.parentNode.host;
        else el = el.parentElement;
    }
    depths.set(owner, depth);
    return depth;
}
// packages/alpinejs/src/reactivity.js
var $b697b2a0f6242b3c$var$reactive;
var $b697b2a0f6242b3c$var$effect;
var $b697b2a0f6242b3c$var$release;
var $b697b2a0f6242b3c$var$raw;
var $b697b2a0f6242b3c$var$nextStructuralEffectOrder = 0;
var $b697b2a0f6242b3c$var$shouldSchedule = true;
function $b697b2a0f6242b3c$var$disableEffectScheduling(callback) {
    $b697b2a0f6242b3c$var$shouldSchedule = false;
    callback();
    $b697b2a0f6242b3c$var$shouldSchedule = true;
}
function $b697b2a0f6242b3c$var$setReactivityEngine(engine) {
    $b697b2a0f6242b3c$var$reactive = engine.reactive;
    $b697b2a0f6242b3c$var$release = engine.release;
    $b697b2a0f6242b3c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($b697b2a0f6242b3c$var$shouldSchedule) $b697b2a0f6242b3c$var$scheduler(task);
                else task();
            }
        });
    $b697b2a0f6242b3c$var$raw = engine.raw;
}
function $b697b2a0f6242b3c$var$overrideEffect(override) {
    $b697b2a0f6242b3c$var$effect = override;
}
function $b697b2a0f6242b3c$var$elementBoundEffect(el) {
    let cleanup = ()=>{};
    let wrappedEffect = (callback, options)=>{
        let priority = options?.priority === "structural" ? $b697b2a0f6242b3c$var$nextStructuralEffectOrder++ : void 0;
        let effectReference = $b697b2a0f6242b3c$var$effect(callback);
        if (priority !== void 0 && effectReference !== void 0) effectReference._x_schedulerPriority = {
            el: el,
            order: priority
        };
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $b697b2a0f6242b3c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup();
        }
    ];
}
function $b697b2a0f6242b3c$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $b697b2a0f6242b3c$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>{
        $b697b2a0f6242b3c$var$dequeueJob(effectReference);
        $b697b2a0f6242b3c$var$release(effectReference);
    };
}
async function $b697b2a0f6242b3c$var$transaction(callback) {
    $b697b2a0f6242b3c$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $b697b2a0f6242b3c$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $b697b2a0f6242b3c$var$onAttributeAddeds = [];
var $b697b2a0f6242b3c$var$onElRemoveds = [];
var $b697b2a0f6242b3c$var$onElAddeds = [];
function $b697b2a0f6242b3c$var$onElAdded(callback) {
    $b697b2a0f6242b3c$var$onElAddeds.push(callback);
}
function $b697b2a0f6242b3c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $b697b2a0f6242b3c$var$onElRemoveds.push(callback);
    }
}
function $b697b2a0f6242b3c$var$onAttributesAdded(callback) {
    $b697b2a0f6242b3c$var$onAttributeAddeds.push(callback);
}
function $b697b2a0f6242b3c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $b697b2a0f6242b3c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $b697b2a0f6242b3c$var$cleanupElement(el) {
    el._x_effects?.forEach($b697b2a0f6242b3c$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $b697b2a0f6242b3c$var$observer = new MutationObserver($b697b2a0f6242b3c$var$onMutate);
var $b697b2a0f6242b3c$var$currentlyObserving = false;
function $b697b2a0f6242b3c$var$startObservingMutations() {
    $b697b2a0f6242b3c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $b697b2a0f6242b3c$var$currentlyObserving = true;
}
function $b697b2a0f6242b3c$var$stopObservingMutations() {
    $b697b2a0f6242b3c$var$flushObserver();
    $b697b2a0f6242b3c$var$observer.disconnect();
    $b697b2a0f6242b3c$var$currentlyObserving = false;
}
var $b697b2a0f6242b3c$var$queuedMutations = [];
function $b697b2a0f6242b3c$var$flushObserver() {
    let records = $b697b2a0f6242b3c$var$observer.takeRecords();
    $b697b2a0f6242b3c$var$queuedMutations.push(()=>records.length > 0 && $b697b2a0f6242b3c$var$onMutate(records));
    let queueLengthWhenTriggered = $b697b2a0f6242b3c$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($b697b2a0f6242b3c$var$queuedMutations.length === queueLengthWhenTriggered) while($b697b2a0f6242b3c$var$queuedMutations.length > 0)$b697b2a0f6242b3c$var$queuedMutations.shift()();
    });
}
function $b697b2a0f6242b3c$var$flushPendingMutations() {
    while($b697b2a0f6242b3c$var$queuedMutations.length > 0)$b697b2a0f6242b3c$var$queuedMutations.shift()();
    let records = $b697b2a0f6242b3c$var$observer.takeRecords();
    if (records.length > 0) $b697b2a0f6242b3c$var$onMutate(records);
}
function $b697b2a0f6242b3c$var$mutateDom(callback) {
    if (!$b697b2a0f6242b3c$var$currentlyObserving) return callback();
    $b697b2a0f6242b3c$var$stopObservingMutations();
    try {
        return callback();
    } finally{
        $b697b2a0f6242b3c$var$startObservingMutations();
    }
}
var $b697b2a0f6242b3c$var$isCollecting = false;
var $b697b2a0f6242b3c$var$deferredMutations = [];
function $b697b2a0f6242b3c$var$deferMutations() {
    $b697b2a0f6242b3c$var$isCollecting = true;
}
function $b697b2a0f6242b3c$var$flushAndStopDeferringMutations() {
    $b697b2a0f6242b3c$var$isCollecting = false;
    $b697b2a0f6242b3c$var$onMutate($b697b2a0f6242b3c$var$deferredMutations);
    $b697b2a0f6242b3c$var$deferredMutations = [];
}
function $b697b2a0f6242b3c$var$onMutate(mutations) {
    if ($b697b2a0f6242b3c$var$isCollecting) {
        $b697b2a0f6242b3c$var$deferredMutations = $b697b2a0f6242b3c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove2 = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add();
            else if (el.hasAttribute(name)) {
                remove2();
                add();
            } else remove2();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $b697b2a0f6242b3c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $b697b2a0f6242b3c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $b697b2a0f6242b3c$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $b697b2a0f6242b3c$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $b697b2a0f6242b3c$var$scope(node) {
    return $b697b2a0f6242b3c$var$mergeProxies($b697b2a0f6242b3c$var$closestDataStack(node));
}
function $b697b2a0f6242b3c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$b697b2a0f6242b3c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $b697b2a0f6242b3c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $b697b2a0f6242b3c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $b697b2a0f6242b3c$var$closestDataStack(node.parentNode);
}
function $b697b2a0f6242b3c$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $b697b2a0f6242b3c$var$mergeProxyTrap);
}
function $b697b2a0f6242b3c$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $b697b2a0f6242b3c$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $b697b2a0f6242b3c$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $b697b2a0f6242b3c$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $b697b2a0f6242b3c$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $b697b2a0f6242b3c$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $b697b2a0f6242b3c$var$initInterceptors(data2, cleanup = ()=>{}) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key, cleanup);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $b697b2a0f6242b3c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key, cleanup) {
            return callback(this.initialValue, ()=>$b697b2a0f6242b3c$var$get(data2, path), (value)=>$b697b2a0f6242b3c$var$set(data2, path, value), path, key, cleanup);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key, cleanup)=>{
                let innerValue = initialValue.initialize(data2, path, key, cleanup);
                obj.initialValue = innerValue;
                return initialize(data2, path, key, cleanup);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $b697b2a0f6242b3c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $b697b2a0f6242b3c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $b697b2a0f6242b3c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $b697b2a0f6242b3c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $b697b2a0f6242b3c$var$magics = {};
function $b697b2a0f6242b3c$var$magic(name, callback) {
    $b697b2a0f6242b3c$var$magics[name] = callback;
}
function $b697b2a0f6242b3c$var$injectMagics(obj, el) {
    let memoizedUtilities = $b697b2a0f6242b3c$var$getUtilities(el);
    Object.entries($b697b2a0f6242b3c$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $b697b2a0f6242b3c$var$getUtilities(el) {
    let [utilities, cleanup] = $b697b2a0f6242b3c$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $b697b2a0f6242b3c$var$interceptor,
        ...utilities
    };
    $b697b2a0f6242b3c$var$onElRemoved(el, cleanup);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $b697b2a0f6242b3c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $b697b2a0f6242b3c$var$handleError(e, el, expression);
    }
}
function $b697b2a0f6242b3c$var$handleError(...args) {
    return $b697b2a0f6242b3c$var$errorHandler(...args);
}
var $b697b2a0f6242b3c$var$errorHandler = $b697b2a0f6242b3c$var$normalErrorHandler;
function $b697b2a0f6242b3c$var$setErrorHandler(handler4) {
    $b697b2a0f6242b3c$var$errorHandler = handler4;
}
function $b697b2a0f6242b3c$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $b697b2a0f6242b3c$var$shouldAutoEvaluateFunctions = true;
function $b697b2a0f6242b3c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $b697b2a0f6242b3c$var$shouldAutoEvaluateFunctions;
    $b697b2a0f6242b3c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $b697b2a0f6242b3c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $b697b2a0f6242b3c$var$evaluate(el, expression, extras = {}) {
    let result;
    $b697b2a0f6242b3c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $b697b2a0f6242b3c$var$evaluateLater(...args) {
    return $b697b2a0f6242b3c$var$theEvaluatorFunction(...args);
}
var $b697b2a0f6242b3c$var$theEvaluatorFunction = ()=>{};
function $b697b2a0f6242b3c$var$setEvaluator(newEvaluator) {
    $b697b2a0f6242b3c$var$theEvaluatorFunction = newEvaluator;
}
var $b697b2a0f6242b3c$var$theRawEvaluatorFunction;
function $b697b2a0f6242b3c$var$setRawEvaluator(newEvaluator) {
    $b697b2a0f6242b3c$var$theRawEvaluatorFunction = newEvaluator;
}
function $b697b2a0f6242b3c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $b697b2a0f6242b3c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$b697b2a0f6242b3c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $b697b2a0f6242b3c$var$generateEvaluatorFromFunction(dataStack, expression) : $b697b2a0f6242b3c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $b697b2a0f6242b3c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $b697b2a0f6242b3c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$b697b2a0f6242b3c$var$shouldAutoEvaluateFunctions) {
            $b697b2a0f6242b3c$var$runIfTypeOfFunction(receiver, func, $b697b2a0f6242b3c$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($b697b2a0f6242b3c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $b697b2a0f6242b3c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $b697b2a0f6242b3c$var$evaluatorMemo = {};
function $b697b2a0f6242b3c$var$generateFunctionFromString(expression, el) {
    if ($b697b2a0f6242b3c$var$evaluatorMemo[expression]) return $b697b2a0f6242b3c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $b697b2a0f6242b3c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $b697b2a0f6242b3c$var$evaluatorMemo[expression] = func;
    return func;
}
function $b697b2a0f6242b3c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $b697b2a0f6242b3c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $b697b2a0f6242b3c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$b697b2a0f6242b3c$var$handleError(error2, el, expression));
            if (func.finished) {
                $b697b2a0f6242b3c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $b697b2a0f6242b3c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$b697b2a0f6242b3c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $b697b2a0f6242b3c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($b697b2a0f6242b3c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$b697b2a0f6242b3c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$b697b2a0f6242b3c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $b697b2a0f6242b3c$var$evaluateRaw(...args) {
    return $b697b2a0f6242b3c$var$theRawEvaluatorFunction(...args);
}
function $b697b2a0f6242b3c$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $b697b2a0f6242b3c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$b697b2a0f6242b3c$var$closestDataStack(el)
    ];
    let scope2 = $b697b2a0f6242b3c$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $b697b2a0f6242b3c$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $b697b2a0f6242b3c$var$prefixAsString = "x-";
function $b697b2a0f6242b3c$var$prefix(subject = "") {
    return $b697b2a0f6242b3c$var$prefixAsString + subject;
}
function $b697b2a0f6242b3c$var$setPrefix(newPrefix) {
    $b697b2a0f6242b3c$var$prefixAsString = newPrefix;
}
var $b697b2a0f6242b3c$var$directiveHandlers = {};
function $b697b2a0f6242b3c$var$directive(name, callback) {
    $b697b2a0f6242b3c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$b697b2a0f6242b3c$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $b697b2a0f6242b3c$var$directiveOrder.indexOf(directive2);
            $b697b2a0f6242b3c$var$directiveOrder.splice(pos >= 0 ? pos : $b697b2a0f6242b3c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $b697b2a0f6242b3c$var$directiveExists(name) {
    return Object.keys($b697b2a0f6242b3c$var$directiveHandlers).includes(name);
}
function $b697b2a0f6242b3c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $b697b2a0f6242b3c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($b697b2a0f6242b3c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($b697b2a0f6242b3c$var$outNonAlpineAttributes).map($b697b2a0f6242b3c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($b697b2a0f6242b3c$var$byPriority);
    return directives2.map((directive2)=>{
        return $b697b2a0f6242b3c$var$getDirectiveHandler(el, directive2);
    });
}
function $b697b2a0f6242b3c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($b697b2a0f6242b3c$var$toTransformedAttributes()).filter((attr)=>!$b697b2a0f6242b3c$var$outNonAlpineAttributes(attr));
}
var $b697b2a0f6242b3c$var$isDeferringHandlers = false;
var $b697b2a0f6242b3c$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $b697b2a0f6242b3c$var$currentHandlerStackKey = Symbol();
function $b697b2a0f6242b3c$var$deferHandlingDirectives(callback) {
    $b697b2a0f6242b3c$var$isDeferringHandlers = true;
    let key = Symbol();
    $b697b2a0f6242b3c$var$currentHandlerStackKey = key;
    $b697b2a0f6242b3c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($b697b2a0f6242b3c$var$directiveHandlerStacks.get(key).length)$b697b2a0f6242b3c$var$directiveHandlerStacks.get(key).shift()();
        $b697b2a0f6242b3c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $b697b2a0f6242b3c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $b697b2a0f6242b3c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect2] = $b697b2a0f6242b3c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect2);
    let utilities = {
        Alpine: $b697b2a0f6242b3c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup,
        evaluateLater: $b697b2a0f6242b3c$var$evaluateLater.bind($b697b2a0f6242b3c$var$evaluateLater, el),
        evaluate: $b697b2a0f6242b3c$var$evaluate.bind($b697b2a0f6242b3c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $b697b2a0f6242b3c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $b697b2a0f6242b3c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup] = $b697b2a0f6242b3c$var$getElementBoundUtilities(el);
    $b697b2a0f6242b3c$var$onAttributeRemoved(el, directive2.original, cleanup);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $b697b2a0f6242b3c$var$isDeferringHandlers ? $b697b2a0f6242b3c$var$directiveHandlerStacks.get($b697b2a0f6242b3c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup;
    return fullHandler;
}
var $b697b2a0f6242b3c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $b697b2a0f6242b3c$var$into = (i)=>i;
function $b697b2a0f6242b3c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $b697b2a0f6242b3c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $b697b2a0f6242b3c$var$attributeTransformers = [];
function $b697b2a0f6242b3c$var$mapAttributes(callback) {
    $b697b2a0f6242b3c$var$attributeTransformers.push(callback);
}
function $b697b2a0f6242b3c$var$outNonAlpineAttributes({ name: name }) {
    return $b697b2a0f6242b3c$var$alpineAttributeRegex().test(name);
}
var $b697b2a0f6242b3c$var$alpineAttributeRegex = ()=>new RegExp(`^${$b697b2a0f6242b3c$var$prefixAsString}([^:^.]+)\\b`);
function $b697b2a0f6242b3c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($b697b2a0f6242b3c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $b697b2a0f6242b3c$var$DEFAULT = "DEFAULT";
var $b697b2a0f6242b3c$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $b697b2a0f6242b3c$var$DEFAULT,
    "teleport"
];
function $b697b2a0f6242b3c$var$byPriority(a, b) {
    let typeA = $b697b2a0f6242b3c$var$directiveOrder.indexOf(a.type) === -1 ? $b697b2a0f6242b3c$var$DEFAULT : a.type;
    let typeB = $b697b2a0f6242b3c$var$directiveOrder.indexOf(b.type) === -1 ? $b697b2a0f6242b3c$var$DEFAULT : b.type;
    return $b697b2a0f6242b3c$var$directiveOrder.indexOf(typeA) - $b697b2a0f6242b3c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/walk.js
function $b697b2a0f6242b3c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$b697b2a0f6242b3c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $b697b2a0f6242b3c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/clone.js
var $b697b2a0f6242b3c$var$isCloning = false;
function $b697b2a0f6242b3c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$b697b2a0f6242b3c$var$isCloning ? fallback(...args) : callback(...args);
}
function $b697b2a0f6242b3c$var$onlyDuringClone(callback) {
    return (...args)=>$b697b2a0f6242b3c$var$isCloning && callback(...args);
}
var $b697b2a0f6242b3c$var$interceptors = [];
function $b697b2a0f6242b3c$var$interceptClone(callback) {
    $b697b2a0f6242b3c$var$interceptors.push(callback);
}
function $b697b2a0f6242b3c$var$cloneNode(from, to) {
    $b697b2a0f6242b3c$var$interceptors.forEach((i)=>i(from, to));
    $b697b2a0f6242b3c$var$isCloning = true;
    $b697b2a0f6242b3c$var$dontRegisterReactiveSideEffects(()=>{
        $b697b2a0f6242b3c$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $b697b2a0f6242b3c$var$isCloning = false;
}
var $b697b2a0f6242b3c$var$isCloningLegacy = false;
function $b697b2a0f6242b3c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $b697b2a0f6242b3c$var$isCloning = true;
    $b697b2a0f6242b3c$var$isCloningLegacy = true;
    $b697b2a0f6242b3c$var$dontRegisterReactiveSideEffects(()=>{
        $b697b2a0f6242b3c$var$cloneTree(newEl);
    });
    $b697b2a0f6242b3c$var$isCloning = false;
    $b697b2a0f6242b3c$var$isCloningLegacy = false;
}
function $b697b2a0f6242b3c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $b697b2a0f6242b3c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $b697b2a0f6242b3c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $b697b2a0f6242b3c$var$initTree(el, shallowWalker);
}
function $b697b2a0f6242b3c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $b697b2a0f6242b3c$var$effect;
    $b697b2a0f6242b3c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $b697b2a0f6242b3c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $b697b2a0f6242b3c$var$overrideEffect(cache);
}
// packages/alpinejs/src/deferInit.js
var $b697b2a0f6242b3c$var$activeDefers = 0;
function $b697b2a0f6242b3c$var$deferInit(el, promise) {
    let record = el._x_deferInit;
    if (!record) {
        record = el._x_deferInit = {
            pending: 0,
            ownsIgnore: !el._x_ignore,
            queuedAttributes: /* @__PURE__ */ new Map()
        };
        if (record.ownsIgnore) el._x_ignore = true;
        $b697b2a0f6242b3c$var$activeDefers++;
    }
    record.pending++;
    Promise.resolve(promise).catch((error2)=>{
        try {
            $b697b2a0f6242b3c$var$handleError(error2, el);
        } catch (error3) {
            setTimeout(()=>{
                throw error3;
            }, 0);
        }
    }).then(()=>$b697b2a0f6242b3c$var$settle(el, record));
}
function $b697b2a0f6242b3c$var$settle(el, record) {
    record.pending--;
    if (record.pending > 0) return;
    $b697b2a0f6242b3c$var$flushPendingMutations();
    if (record.pending > 0) return;
    if (el._x_deferInit !== record) return;
    delete el._x_deferInit;
    if (record.ownsIgnore) delete el._x_ignore;
    $b697b2a0f6242b3c$var$activeDefers--;
    if (!el.isConnected) return;
    $b697b2a0f6242b3c$var$replayQueuedAttributes(record);
    $b697b2a0f6242b3c$var$initTree(el);
}
function $b697b2a0f6242b3c$var$queueAttributesForDeferredTree(el, attrs) {
    if ($b697b2a0f6242b3c$var$activeDefers === 0) return false;
    let root = $b697b2a0f6242b3c$var$findClosest(el, (i)=>i._x_deferInit);
    if (!root) return false;
    $b697b2a0f6242b3c$var$queueInto(root._x_deferInit, el, attrs.map(({ name: name })=>name));
    return true;
}
function $b697b2a0f6242b3c$var$queueInto(record, el, names) {
    let entry = record.queuedAttributes.get(el);
    if (!entry || entry.marker !== el._x_marker) {
        entry = {
            marker: el._x_marker,
            names: /* @__PURE__ */ new Set()
        };
        record.queuedAttributes.set(el, entry);
    }
    names.forEach((name)=>entry.names.add(name));
}
function $b697b2a0f6242b3c$var$replayQueuedAttributes(record) {
    record.queuedAttributes.forEach((entry, el)=>{
        if (!el.isConnected) return;
        if (!el._x_marker) return;
        if (el._x_marker !== entry.marker) return;
        let suspendedAncestor = $b697b2a0f6242b3c$var$findClosest(el, (i)=>i._x_deferInit);
        if (suspendedAncestor) {
            $b697b2a0f6242b3c$var$queueInto(suspendedAncestor._x_deferInit, el, Array.from(entry.names));
            return;
        }
        let attrs = Array.from(entry.names).filter((name)=>el.hasAttribute(name)).map((name)=>({
                name: name,
                value: el.getAttribute(name)
            }));
        if (attrs.length === 0) return;
        $b697b2a0f6242b3c$var$directives(el, attrs).forEach((handle)=>handle());
    });
}
$b697b2a0f6242b3c$var$interceptClone((from, to)=>{
    if ($b697b2a0f6242b3c$var$activeDefers === 0) return;
    if (!from || from.nodeType !== 1 || !to || to.nodeType !== 1) return;
    if ($b697b2a0f6242b3c$var$findClosest(from, (i)=>i._x_deferInit)) to._x_ignore = true;
});
// packages/alpinejs/src/utils/dispatch.js
function $b697b2a0f6242b3c$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/warn.js
function $b697b2a0f6242b3c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $b697b2a0f6242b3c$var$started = false;
function $b697b2a0f6242b3c$var$start() {
    if ($b697b2a0f6242b3c$var$started) $b697b2a0f6242b3c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $b697b2a0f6242b3c$var$started = true;
    if (!document.body) $b697b2a0f6242b3c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $b697b2a0f6242b3c$var$dispatch(document, "alpine:init");
    $b697b2a0f6242b3c$var$dispatch(document, "alpine:initializing");
    $b697b2a0f6242b3c$var$startObservingMutations();
    $b697b2a0f6242b3c$var$onElAdded((el)=>$b697b2a0f6242b3c$var$initTree(el, $b697b2a0f6242b3c$var$walk));
    $b697b2a0f6242b3c$var$onElRemoved((el)=>$b697b2a0f6242b3c$var$destroyTree(el));
    $b697b2a0f6242b3c$var$onAttributesAdded((el, attrs)=>{
        if ($b697b2a0f6242b3c$var$queueAttributesForDeferredTree(el, attrs)) return;
        $b697b2a0f6242b3c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$b697b2a0f6242b3c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($b697b2a0f6242b3c$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $b697b2a0f6242b3c$var$initTree(el);
    });
    $b697b2a0f6242b3c$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $b697b2a0f6242b3c$var$warnAboutMissingPlugins();
    });
}
var $b697b2a0f6242b3c$var$rootSelectorCallbacks = [];
var $b697b2a0f6242b3c$var$initSelectorCallbacks = [];
function $b697b2a0f6242b3c$var$rootSelectors() {
    return $b697b2a0f6242b3c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $b697b2a0f6242b3c$var$allSelectors() {
    return $b697b2a0f6242b3c$var$rootSelectorCallbacks.concat($b697b2a0f6242b3c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $b697b2a0f6242b3c$var$addRootSelector(selectorCallback) {
    $b697b2a0f6242b3c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $b697b2a0f6242b3c$var$addInitSelector(selectorCallback) {
    $b697b2a0f6242b3c$var$initSelectorCallbacks.push(selectorCallback);
}
function $b697b2a0f6242b3c$var$closestRoot(el, includeInitSelectors = false) {
    return $b697b2a0f6242b3c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $b697b2a0f6242b3c$var$allSelectors() : $b697b2a0f6242b3c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $b697b2a0f6242b3c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $b697b2a0f6242b3c$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $b697b2a0f6242b3c$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $b697b2a0f6242b3c$var$findClosest(el.parentElement, callback);
}
function $b697b2a0f6242b3c$var$isRoot(el) {
    return $b697b2a0f6242b3c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $b697b2a0f6242b3c$var$initInterceptors2 = [];
function $b697b2a0f6242b3c$var$interceptInit(callback) {
    $b697b2a0f6242b3c$var$initInterceptors2.push(callback);
}
var $b697b2a0f6242b3c$var$markerDispenser = 1;
function $b697b2a0f6242b3c$var$initTree(el, walker = $b697b2a0f6242b3c$var$walk, intercept = ()=>{}) {
    if ($b697b2a0f6242b3c$var$findClosest(el, (i)=>i._x_ignore)) return;
    $b697b2a0f6242b3c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $b697b2a0f6242b3c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $b697b2a0f6242b3c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $b697b2a0f6242b3c$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $b697b2a0f6242b3c$var$destroyTree(root, walker = $b697b2a0f6242b3c$var$walk) {
    walker(root, (el)=>{
        $b697b2a0f6242b3c$var$cleanupElement(el);
        $b697b2a0f6242b3c$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $b697b2a0f6242b3c$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($b697b2a0f6242b3c$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $b697b2a0f6242b3c$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $b697b2a0f6242b3c$var$tickStack = [];
var $b697b2a0f6242b3c$var$isHolding = false;
function $b697b2a0f6242b3c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $b697b2a0f6242b3c$var$isHolding || setTimeout(()=>{
            $b697b2a0f6242b3c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $b697b2a0f6242b3c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $b697b2a0f6242b3c$var$releaseNextTicks() {
    $b697b2a0f6242b3c$var$isHolding = false;
    while($b697b2a0f6242b3c$var$tickStack.length)$b697b2a0f6242b3c$var$tickStack.shift()();
}
function $b697b2a0f6242b3c$var$holdNextTicks() {
    $b697b2a0f6242b3c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $b697b2a0f6242b3c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $b697b2a0f6242b3c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $b697b2a0f6242b3c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $b697b2a0f6242b3c$var$setClasses(el, value());
    return $b697b2a0f6242b3c$var$setClassesFromString(el, value);
}
function $b697b2a0f6242b3c$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $b697b2a0f6242b3c$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$b697b2a0f6242b3c$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $b697b2a0f6242b3c$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $b697b2a0f6242b3c$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $b697b2a0f6242b3c$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $b697b2a0f6242b3c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $b697b2a0f6242b3c$var$setStylesFromObject(el, value);
    return $b697b2a0f6242b3c$var$setStylesFromString(el, value);
}
function $b697b2a0f6242b3c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $b697b2a0f6242b3c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $b697b2a0f6242b3c$var$setStyles(el, previousStyles);
    };
}
function $b697b2a0f6242b3c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $b697b2a0f6242b3c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $b697b2a0f6242b3c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$b697b2a0f6242b3c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $b697b2a0f6242b3c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $b697b2a0f6242b3c$var$registerTransitionsFromClassString(el, expression, value);
});
function $b697b2a0f6242b3c$var$registerTransitionsFromClassString(el, classString, stage) {
    $b697b2a0f6242b3c$var$registerTransitionObject(el, $b697b2a0f6242b3c$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $b697b2a0f6242b3c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $b697b2a0f6242b3c$var$registerTransitionObject(el, $b697b2a0f6242b3c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $b697b2a0f6242b3c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $b697b2a0f6242b3c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $b697b2a0f6242b3c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $b697b2a0f6242b3c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $b697b2a0f6242b3c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $b697b2a0f6242b3c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $b697b2a0f6242b3c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $b697b2a0f6242b3c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $b697b2a0f6242b3c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $b697b2a0f6242b3c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $b697b2a0f6242b3c$var$closestHide(parent);
}
function $b697b2a0f6242b3c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $b697b2a0f6242b3c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $b697b2a0f6242b3c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $b697b2a0f6242b3c$var$once(()=>{
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $b697b2a0f6242b3c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $b697b2a0f6242b3c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $b697b2a0f6242b3c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $b697b2a0f6242b3c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $b697b2a0f6242b3c$var$mutateDom(()=>{
                stages.end();
            });
            $b697b2a0f6242b3c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $b697b2a0f6242b3c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/utils/bind.js
function $b697b2a0f6242b3c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $b697b2a0f6242b3c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $b697b2a0f6242b3c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $b697b2a0f6242b3c$var$bindInputValue(el, value);
            break;
        case "style":
            $b697b2a0f6242b3c$var$bindStyles(el, value);
            break;
        case "class":
            $b697b2a0f6242b3c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $b697b2a0f6242b3c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $b697b2a0f6242b3c$var$bindAttribute(el, name, value);
            break;
    }
}
function $b697b2a0f6242b3c$var$bindInputValue(el, value) {
    if ($b697b2a0f6242b3c$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($b697b2a0f6242b3c$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$b697b2a0f6242b3c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $b697b2a0f6242b3c$var$updateSelect(el, value);
    else if (el.tagName === "OPTION") $b697b2a0f6242b3c$var$bindAttribute(el, "value", value);
    else {
        if (el.value === value && (typeof value !== "object" || value === null)) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $b697b2a0f6242b3c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $b697b2a0f6242b3c$var$setClasses(el, value);
}
function $b697b2a0f6242b3c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $b697b2a0f6242b3c$var$setStyles(el, value);
}
function $b697b2a0f6242b3c$var$bindAttributeAndProperty(el, name, value) {
    $b697b2a0f6242b3c$var$bindAttribute(el, name, value);
    $b697b2a0f6242b3c$var$setPropertyIfChanged(el, name, value);
}
function $b697b2a0f6242b3c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $b697b2a0f6242b3c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($b697b2a0f6242b3c$var$isBooleanAttr(name)) value = name;
        if ($b697b2a0f6242b3c$var$isObjectAttr(value)) value = JSON.stringify(value);
        $b697b2a0f6242b3c$var$setIfChanged(el, name, value);
    }
}
function $b697b2a0f6242b3c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $b697b2a0f6242b3c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $b697b2a0f6242b3c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $b697b2a0f6242b3c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $b697b2a0f6242b3c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $b697b2a0f6242b3c$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $b697b2a0f6242b3c$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $b697b2a0f6242b3c$var$isBooleanAttr(attrName) {
    return $b697b2a0f6242b3c$var$booleanAttributes.has(attrName);
}
function $b697b2a0f6242b3c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $b697b2a0f6242b3c$var$isObjectAttr(value) {
    return typeof value === "object" && value !== null;
}
function $b697b2a0f6242b3c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $b697b2a0f6242b3c$var$getAttributeBinding(el, name, fallback);
}
function $b697b2a0f6242b3c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $b697b2a0f6242b3c$var$dontAutoEvaluateFunctions(()=>{
            return $b697b2a0f6242b3c$var$evaluate(el, binding.expression);
        });
    }
    return $b697b2a0f6242b3c$var$getAttributeBinding(el, name, fallback);
}
function $b697b2a0f6242b3c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($b697b2a0f6242b3c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $b697b2a0f6242b3c$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $b697b2a0f6242b3c$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $b697b2a0f6242b3c$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $b697b2a0f6242b3c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $b697b2a0f6242b3c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $b697b2a0f6242b3c$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($b697b2a0f6242b3c$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($b697b2a0f6242b3c$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($b697b2a0f6242b3c$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $b697b2a0f6242b3c$var$dequeueJob(reference);
        $b697b2a0f6242b3c$var$release(reference);
    };
}
function $b697b2a0f6242b3c$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $b697b2a0f6242b3c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($b697b2a0f6242b3c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $b697b2a0f6242b3c$var$stores = {};
var $b697b2a0f6242b3c$var$isReactive = false;
function $b697b2a0f6242b3c$var$store(name, value) {
    if (!$b697b2a0f6242b3c$var$isReactive) {
        $b697b2a0f6242b3c$var$stores = $b697b2a0f6242b3c$var$reactive($b697b2a0f6242b3c$var$stores);
        $b697b2a0f6242b3c$var$isReactive = true;
    }
    if (value === void 0) return $b697b2a0f6242b3c$var$stores[name];
    $b697b2a0f6242b3c$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value._x_interceptor) $b697b2a0f6242b3c$var$stores[name] = value.initialize($b697b2a0f6242b3c$var$stores, name, name, ()=>{});
    else $b697b2a0f6242b3c$var$initInterceptors($b697b2a0f6242b3c$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $b697b2a0f6242b3c$var$stores[name].init();
}
function $b697b2a0f6242b3c$var$getStores() {
    return $b697b2a0f6242b3c$var$stores;
}
// packages/alpinejs/src/binds.js
var $b697b2a0f6242b3c$var$binds = {};
function $b697b2a0f6242b3c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $b697b2a0f6242b3c$var$applyBindingsObject(name, getBindings());
    else $b697b2a0f6242b3c$var$binds[name] = getBindings;
    return ()=>{};
}
function $b697b2a0f6242b3c$var$injectBindingProviders(obj) {
    Object.entries($b697b2a0f6242b3c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $b697b2a0f6242b3c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $b697b2a0f6242b3c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $b697b2a0f6242b3c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $b697b2a0f6242b3c$var$datas = {};
function $b697b2a0f6242b3c$var$data(name, callback) {
    $b697b2a0f6242b3c$var$datas[name] = callback;
}
function $b697b2a0f6242b3c$var$injectDataProviders(obj, context) {
    Object.entries($b697b2a0f6242b3c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $b697b2a0f6242b3c$var$Alpine = {
    get reactive () {
        return $b697b2a0f6242b3c$var$reactive;
    },
    get release () {
        return $b697b2a0f6242b3c$var$release;
    },
    get effect () {
        return $b697b2a0f6242b3c$var$effect;
    },
    get raw () {
        return $b697b2a0f6242b3c$var$raw;
    },
    get transaction () {
        return $b697b2a0f6242b3c$var$transaction;
    },
    version: "3.17.5",
    flushAndStopDeferringMutations: $b697b2a0f6242b3c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $b697b2a0f6242b3c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $b697b2a0f6242b3c$var$disableEffectScheduling,
    startObservingMutations: $b697b2a0f6242b3c$var$startObservingMutations,
    stopObservingMutations: $b697b2a0f6242b3c$var$stopObservingMutations,
    setReactivityEngine: $b697b2a0f6242b3c$var$setReactivityEngine,
    onAttributeRemoved: $b697b2a0f6242b3c$var$onAttributeRemoved,
    onAttributesAdded: $b697b2a0f6242b3c$var$onAttributesAdded,
    closestDataStack: $b697b2a0f6242b3c$var$closestDataStack,
    skipDuringClone: $b697b2a0f6242b3c$var$skipDuringClone,
    onlyDuringClone: $b697b2a0f6242b3c$var$onlyDuringClone,
    addRootSelector: $b697b2a0f6242b3c$var$addRootSelector,
    addInitSelector: $b697b2a0f6242b3c$var$addInitSelector,
    setErrorHandler: $b697b2a0f6242b3c$var$setErrorHandler,
    interceptClone: $b697b2a0f6242b3c$var$interceptClone,
    addScopeToNode: $b697b2a0f6242b3c$var$addScopeToNode,
    deferMutations: $b697b2a0f6242b3c$var$deferMutations,
    mapAttributes: $b697b2a0f6242b3c$var$mapAttributes,
    evaluateLater: $b697b2a0f6242b3c$var$evaluateLater,
    interceptInit: $b697b2a0f6242b3c$var$interceptInit,
    initInterceptors: $b697b2a0f6242b3c$var$initInterceptors,
    injectMagics: $b697b2a0f6242b3c$var$injectMagics,
    setEvaluator: $b697b2a0f6242b3c$var$setEvaluator,
    setRawEvaluator: $b697b2a0f6242b3c$var$setRawEvaluator,
    mergeProxies: $b697b2a0f6242b3c$var$mergeProxies,
    extractProp: $b697b2a0f6242b3c$var$extractProp,
    findClosest: $b697b2a0f6242b3c$var$findClosest,
    onElRemoved: $b697b2a0f6242b3c$var$onElRemoved,
    closestRoot: $b697b2a0f6242b3c$var$closestRoot,
    destroyTree: $b697b2a0f6242b3c$var$destroyTree,
    interceptor: $b697b2a0f6242b3c$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $b697b2a0f6242b3c$var$transition,
    setStyles: // INTERNAL
    $b697b2a0f6242b3c$var$setStyles,
    mutateDom: // INTERNAL
    $b697b2a0f6242b3c$var$mutateDom,
    deferInit: $b697b2a0f6242b3c$var$deferInit,
    directive: $b697b2a0f6242b3c$var$directive,
    entangle: $b697b2a0f6242b3c$var$entangle,
    throttle: $b697b2a0f6242b3c$var$throttle,
    debounce: $b697b2a0f6242b3c$var$debounce,
    evaluate: $b697b2a0f6242b3c$var$evaluate,
    evaluateRaw: $b697b2a0f6242b3c$var$evaluateRaw,
    initTree: $b697b2a0f6242b3c$var$initTree,
    nextTick: $b697b2a0f6242b3c$var$nextTick,
    prefixed: $b697b2a0f6242b3c$var$prefix,
    prefix: $b697b2a0f6242b3c$var$setPrefix,
    plugin: $b697b2a0f6242b3c$var$plugin,
    magic: $b697b2a0f6242b3c$var$magic,
    store: $b697b2a0f6242b3c$var$store,
    start: $b697b2a0f6242b3c$var$start,
    clone: $b697b2a0f6242b3c$var$clone,
    cloneNode: // INTERNAL
    $b697b2a0f6242b3c$var$cloneNode,
    // INTERNAL
    bound: $b697b2a0f6242b3c$var$getBinding,
    $data: $b697b2a0f6242b3c$var$scope,
    watch: $b697b2a0f6242b3c$var$watch,
    walk: $b697b2a0f6242b3c$var$walk,
    data: $b697b2a0f6242b3c$var$data,
    bind: $b697b2a0f6242b3c$var$bind2
};
var $b697b2a0f6242b3c$var$alpine_default = $b697b2a0f6242b3c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $b697b2a0f6242b3c$var$makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
var $b697b2a0f6242b3c$var$EMPTY_OBJ = Object.freeze({});
var $b697b2a0f6242b3c$var$EMPTY_ARR = Object.freeze([]);
var $b697b2a0f6242b3c$var$extend = Object.assign;
var $b697b2a0f6242b3c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b697b2a0f6242b3c$var$hasOwn = (val, key)=>$b697b2a0f6242b3c$var$hasOwnProperty.call(val, key);
var $b697b2a0f6242b3c$var$isArray = Array.isArray;
var $b697b2a0f6242b3c$var$isMap = (val)=>$b697b2a0f6242b3c$var$toTypeString(val) === "[object Map]";
var $b697b2a0f6242b3c$var$isString = (val)=>typeof val === "string";
var $b697b2a0f6242b3c$var$isSymbol = (val)=>typeof val === "symbol";
var $b697b2a0f6242b3c$var$isObject = (val)=>val !== null && typeof val === "object";
var $b697b2a0f6242b3c$var$objectToString = Object.prototype.toString;
var $b697b2a0f6242b3c$var$toTypeString = (value)=>$b697b2a0f6242b3c$var$objectToString.call(value);
var $b697b2a0f6242b3c$var$toRawType = (value)=>{
    return $b697b2a0f6242b3c$var$toTypeString(value).slice(8, -1);
};
var $b697b2a0f6242b3c$var$isIntegerKey = (key)=>$b697b2a0f6242b3c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $b697b2a0f6242b3c$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $b697b2a0f6242b3c$var$camelizeRE = /-\w/g;
var $b697b2a0f6242b3c$var$camelize = $b697b2a0f6242b3c$var$cacheStringFunction((str)=>{
    return str.replace($b697b2a0f6242b3c$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
var $b697b2a0f6242b3c$var$hyphenateRE = /\B([A-Z])/g;
var $b697b2a0f6242b3c$var$hyphenate = $b697b2a0f6242b3c$var$cacheStringFunction((str)=>str.replace($b697b2a0f6242b3c$var$hyphenateRE, "-$1").toLowerCase());
var $b697b2a0f6242b3c$var$capitalize = $b697b2a0f6242b3c$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $b697b2a0f6242b3c$var$toHandlerKey = $b697b2a0f6242b3c$var$cacheStringFunction((str)=>{
    const s = str ? `on${$b697b2a0f6242b3c$var$capitalize(str)}` : ``;
    return s;
});
var $b697b2a0f6242b3c$var$hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
var $b697b2a0f6242b3c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $b697b2a0f6242b3c$var$isBooleanAttr2 = /* @__PURE__ */ $b697b2a0f6242b3c$var$makeMap($b697b2a0f6242b3c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function $b697b2a0f6242b3c$var$warn2(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
var $b697b2a0f6242b3c$var$activeEffectScope;
var $b697b2a0f6242b3c$var$activeSub;
var $b697b2a0f6242b3c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
var $b697b2a0f6242b3c$var$ReactiveEffect = class {
    constructor(fn){
        this.fn = fn;
        this.deps = void 0;
        this.depsTail = void 0;
        this.flags = 5;
        this.next = void 0;
        this.cleanup = void 0;
        this.scheduler = void 0;
        if ($b697b2a0f6242b3c$var$activeEffectScope) {
            if ($b697b2a0f6242b3c$var$activeEffectScope.active) $b697b2a0f6242b3c$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($b697b2a0f6242b3c$var$pausedQueueEffects.has(this)) {
                $b697b2a0f6242b3c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $b697b2a0f6242b3c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $b697b2a0f6242b3c$var$cleanupEffect(this);
        $b697b2a0f6242b3c$var$prepareDeps(this);
        const prevEffect = $b697b2a0f6242b3c$var$activeSub;
        const prevShouldTrack = $b697b2a0f6242b3c$var$shouldTrack;
        $b697b2a0f6242b3c$var$activeSub = this;
        $b697b2a0f6242b3c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            if ($b697b2a0f6242b3c$var$activeSub !== this) $b697b2a0f6242b3c$var$warn2("Active effect was not restored correctly - this is likely a Vue internal bug.");
            $b697b2a0f6242b3c$var$cleanupDeps(this);
            $b697b2a0f6242b3c$var$activeSub = prevEffect;
            $b697b2a0f6242b3c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$b697b2a0f6242b3c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $b697b2a0f6242b3c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $b697b2a0f6242b3c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($b697b2a0f6242b3c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $b697b2a0f6242b3c$var$isDirty(this);
    }
};
var $b697b2a0f6242b3c$var$batchDepth = 0;
var $b697b2a0f6242b3c$var$batchedSub;
var $b697b2a0f6242b3c$var$batchedComputed;
function $b697b2a0f6242b3c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $b697b2a0f6242b3c$var$batchedComputed;
        $b697b2a0f6242b3c$var$batchedComputed = sub;
        return;
    }
    sub.next = $b697b2a0f6242b3c$var$batchedSub;
    $b697b2a0f6242b3c$var$batchedSub = sub;
}
function $b697b2a0f6242b3c$var$startBatch() {
    $b697b2a0f6242b3c$var$batchDepth++;
}
function $b697b2a0f6242b3c$var$endBatch() {
    if (--$b697b2a0f6242b3c$var$batchDepth > 0) return;
    if ($b697b2a0f6242b3c$var$batchedComputed) {
        let e = $b697b2a0f6242b3c$var$batchedComputed;
        $b697b2a0f6242b3c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error2;
    while($b697b2a0f6242b3c$var$batchedSub){
        let e = $b697b2a0f6242b3c$var$batchedSub;
        $b697b2a0f6242b3c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error2) error2 = err;
            }
            e = next;
        }
    }
    if (error2) throw error2;
}
function $b697b2a0f6242b3c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $b697b2a0f6242b3c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $b697b2a0f6242b3c$var$removeSub(link);
            $b697b2a0f6242b3c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $b697b2a0f6242b3c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($b697b2a0f6242b3c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $b697b2a0f6242b3c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $b697b2a0f6242b3c$var$globalVersion) return;
    computed.globalVersion = $b697b2a0f6242b3c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$b697b2a0f6242b3c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $b697b2a0f6242b3c$var$activeSub;
    const prevShouldTrack = $b697b2a0f6242b3c$var$shouldTrack;
    $b697b2a0f6242b3c$var$activeSub = computed;
    $b697b2a0f6242b3c$var$shouldTrack = true;
    try {
        $b697b2a0f6242b3c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || $b697b2a0f6242b3c$var$hasChanged(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $b697b2a0f6242b3c$var$activeSub = prevSub;
        $b697b2a0f6242b3c$var$shouldTrack = prevShouldTrack;
        $b697b2a0f6242b3c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $b697b2a0f6242b3c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subsHead === link) dep.subsHead = nextSub;
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$b697b2a0f6242b3c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $b697b2a0f6242b3c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $b697b2a0f6242b3c$var$effect2(fn, options) {
    if (fn.effect instanceof $b697b2a0f6242b3c$var$ReactiveEffect) fn = fn.effect.fn;
    const e = new $b697b2a0f6242b3c$var$ReactiveEffect(fn);
    if (options) $b697b2a0f6242b3c$var$extend(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $b697b2a0f6242b3c$var$stop(runner) {
    runner.effect.stop();
}
var $b697b2a0f6242b3c$var$shouldTrack = true;
var $b697b2a0f6242b3c$var$trackStack = [];
function $b697b2a0f6242b3c$var$pauseTracking() {
    $b697b2a0f6242b3c$var$trackStack.push($b697b2a0f6242b3c$var$shouldTrack);
    $b697b2a0f6242b3c$var$shouldTrack = false;
}
function $b697b2a0f6242b3c$var$resetTracking() {
    const last = $b697b2a0f6242b3c$var$trackStack.pop();
    $b697b2a0f6242b3c$var$shouldTrack = last === void 0 ? true : last;
}
function $b697b2a0f6242b3c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $b697b2a0f6242b3c$var$activeSub;
        $b697b2a0f6242b3c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $b697b2a0f6242b3c$var$activeSub = prevSub;
        }
    }
}
var $b697b2a0f6242b3c$var$globalVersion = 0;
var $b697b2a0f6242b3c$var$Link = class {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
};
var $b697b2a0f6242b3c$var$Dep = class {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        this.activeLink = void 0;
        this.subs = void 0;
        this.map = void 0;
        this.key = void 0;
        this.sc = 0;
        this.__v_skip = true;
        this.subsHead = void 0;
    }
    track(debugInfo) {
        if (!$b697b2a0f6242b3c$var$activeSub || !$b697b2a0f6242b3c$var$shouldTrack || $b697b2a0f6242b3c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $b697b2a0f6242b3c$var$activeSub) {
            link = this.activeLink = new $b697b2a0f6242b3c$var$Link($b697b2a0f6242b3c$var$activeSub, this);
            if (!$b697b2a0f6242b3c$var$activeSub.deps) $b697b2a0f6242b3c$var$activeSub.deps = $b697b2a0f6242b3c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $b697b2a0f6242b3c$var$activeSub.depsTail;
                $b697b2a0f6242b3c$var$activeSub.depsTail.nextDep = link;
                $b697b2a0f6242b3c$var$activeSub.depsTail = link;
            }
            $b697b2a0f6242b3c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $b697b2a0f6242b3c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $b697b2a0f6242b3c$var$activeSub.depsTail.nextDep = link;
                $b697b2a0f6242b3c$var$activeSub.depsTail = link;
                if ($b697b2a0f6242b3c$var$activeSub.deps === link) $b697b2a0f6242b3c$var$activeSub.deps = next;
            }
        }
        if ($b697b2a0f6242b3c$var$activeSub.onTrack) $b697b2a0f6242b3c$var$activeSub.onTrack($b697b2a0f6242b3c$var$extend({
            effect: $b697b2a0f6242b3c$var$activeSub
        }, debugInfo));
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $b697b2a0f6242b3c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $b697b2a0f6242b3c$var$startBatch();
        try {
            for(let head = this.subsHead; head; head = head.nextSub)if (head.sub.onTrigger && !(head.sub.flags & 8)) head.sub.onTrigger($b697b2a0f6242b3c$var$extend({
                effect: head.sub
            }, debugInfo));
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $b697b2a0f6242b3c$var$endBatch();
        }
    }
};
function $b697b2a0f6242b3c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$b697b2a0f6242b3c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        if (link.dep.subsHead === void 0) link.dep.subsHead = link;
        link.dep.subs = link;
    }
}
var $b697b2a0f6242b3c$var$targetMap = /* @__PURE__ */ new WeakMap();
var $b697b2a0f6242b3c$var$ITERATE_KEY = /* @__PURE__ */ Symbol("Object iterate");
var $b697b2a0f6242b3c$var$MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol("Map keys iterate");
var $b697b2a0f6242b3c$var$ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol("Array iterate");
function $b697b2a0f6242b3c$var$track(target, type, key) {
    if ($b697b2a0f6242b3c$var$shouldTrack && $b697b2a0f6242b3c$var$activeSub) {
        let depsMap = $b697b2a0f6242b3c$var$targetMap.get(target);
        if (!depsMap) $b697b2a0f6242b3c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $b697b2a0f6242b3c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track({
            target: target,
            type: type,
            key: key
        });
    }
}
function $b697b2a0f6242b3c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $b697b2a0f6242b3c$var$targetMap.get(target);
    if (!depsMap) {
        $b697b2a0f6242b3c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger({
            target: target,
            type: type,
            key: key,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
    };
    $b697b2a0f6242b3c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = $b697b2a0f6242b3c$var$isArray(target);
        const isArrayIndex = targetIsArray && $b697b2a0f6242b3c$var$isIntegerKey(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $b697b2a0f6242b3c$var$ARRAY_ITERATE_KEY || !$b697b2a0f6242b3c$var$isSymbol(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($b697b2a0f6242b3c$var$ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($b697b2a0f6242b3c$var$ITERATE_KEY));
                        if ($b697b2a0f6242b3c$var$isMap(target)) run(depsMap.get($b697b2a0f6242b3c$var$MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($b697b2a0f6242b3c$var$ITERATE_KEY));
                        if ($b697b2a0f6242b3c$var$isMap(target)) run(depsMap.get($b697b2a0f6242b3c$var$MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ($b697b2a0f6242b3c$var$isMap(target)) run(depsMap.get($b697b2a0f6242b3c$var$ITERATE_KEY));
                    break;
            }
        }
    }
    $b697b2a0f6242b3c$var$endBatch();
}
function $b697b2a0f6242b3c$var$reactiveReadArray(array) {
    const raw2 = $b697b2a0f6242b3c$var$toRaw(array);
    if (raw2 === array) return raw2;
    $b697b2a0f6242b3c$var$track(raw2, "iterate", $b697b2a0f6242b3c$var$ARRAY_ITERATE_KEY);
    return $b697b2a0f6242b3c$var$isShallow(array) ? raw2 : raw2.map($b697b2a0f6242b3c$var$toReactive);
}
function $b697b2a0f6242b3c$var$shallowReadArray(arr) {
    $b697b2a0f6242b3c$var$track(arr = $b697b2a0f6242b3c$var$toRaw(arr), "iterate", $b697b2a0f6242b3c$var$ARRAY_ITERATE_KEY);
    return arr;
}
function $b697b2a0f6242b3c$var$toWrapped(target, item) {
    if ($b697b2a0f6242b3c$var$isReadonly(target)) return $b697b2a0f6242b3c$var$isReactive2(target) ? $b697b2a0f6242b3c$var$toReadonly($b697b2a0f6242b3c$var$toReactive(item)) : $b697b2a0f6242b3c$var$toReadonly(item);
    return $b697b2a0f6242b3c$var$toReactive(item);
}
var $b697b2a0f6242b3c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $b697b2a0f6242b3c$var$iterator(this, Symbol.iterator, (item)=>$b697b2a0f6242b3c$var$toWrapped(this, item));
    },
    concat (...args) {
        return $b697b2a0f6242b3c$var$reactiveReadArray(this).concat(...args.map((x)=>$b697b2a0f6242b3c$var$isArray(x) ? $b697b2a0f6242b3c$var$reactiveReadArray(x) : x));
    },
    entries () {
        return $b697b2a0f6242b3c$var$iterator(this, "entries", (value)=>{
            value[1] = $b697b2a0f6242b3c$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$b697b2a0f6242b3c$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "find", fn, thisArg, (item)=>$b697b2a0f6242b3c$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "findLast", fn, thisArg, (item)=>$b697b2a0f6242b3c$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $b697b2a0f6242b3c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $b697b2a0f6242b3c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $b697b2a0f6242b3c$var$reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $b697b2a0f6242b3c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $b697b2a0f6242b3c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $b697b2a0f6242b3c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $b697b2a0f6242b3c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $b697b2a0f6242b3c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $b697b2a0f6242b3c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $b697b2a0f6242b3c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $b697b2a0f6242b3c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $b697b2a0f6242b3c$var$reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return $b697b2a0f6242b3c$var$reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $b697b2a0f6242b3c$var$reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return $b697b2a0f6242b3c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $b697b2a0f6242b3c$var$iterator(this, "values", (item)=>$b697b2a0f6242b3c$var$toWrapped(this, item));
    }
};
function $b697b2a0f6242b3c$var$iterator(self2, method, wrapValue) {
    const arr = $b697b2a0f6242b3c$var$shallowReadArray(self2);
    const iter = arr[method]();
    if (arr !== self2 && !$b697b2a0f6242b3c$var$isShallow(self2)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
var $b697b2a0f6242b3c$var$arrayProto = Array.prototype;
function $b697b2a0f6242b3c$var$apply(self2, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $b697b2a0f6242b3c$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$b697b2a0f6242b3c$var$isShallow(self2);
    const methodFn = arr[method];
    if (methodFn !== $b697b2a0f6242b3c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self2, args);
        return needsWrap ? $b697b2a0f6242b3c$var$toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self2) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $b697b2a0f6242b3c$var$toWrapped(self2, item), index, self2);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self2);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $b697b2a0f6242b3c$var$reduce(self2, method, fn, args) {
    const arr = $b697b2a0f6242b3c$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$b697b2a0f6242b3c$var$isShallow(self2);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self2) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $b697b2a0f6242b3c$var$toWrapped(self2, acc);
                }
                return fn.call(this, acc, $b697b2a0f6242b3c$var$toWrapped(self2, item), index, self2);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self2);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $b697b2a0f6242b3c$var$toWrapped(self2, result) : result;
}
function $b697b2a0f6242b3c$var$searchProxy(self2, method, args) {
    const arr = $b697b2a0f6242b3c$var$toRaw(self2);
    $b697b2a0f6242b3c$var$track(arr, "iterate", $b697b2a0f6242b3c$var$ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $b697b2a0f6242b3c$var$isProxy(args[0])) {
        args[0] = $b697b2a0f6242b3c$var$toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $b697b2a0f6242b3c$var$noTracking(self2, method, args = []) {
    $b697b2a0f6242b3c$var$pauseTracking();
    $b697b2a0f6242b3c$var$startBatch();
    const res = $b697b2a0f6242b3c$var$toRaw(self2)[method].apply(self2, args);
    $b697b2a0f6242b3c$var$endBatch();
    $b697b2a0f6242b3c$var$resetTracking();
    return res;
}
var $b697b2a0f6242b3c$var$isNonTrackableKeys = /* @__PURE__ */ $b697b2a0f6242b3c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $b697b2a0f6242b3c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter($b697b2a0f6242b3c$var$isSymbol));
function $b697b2a0f6242b3c$var$hasOwnProperty2(key) {
    if (!$b697b2a0f6242b3c$var$isSymbol(key)) key = String(key);
    const obj = $b697b2a0f6242b3c$var$toRaw(this);
    $b697b2a0f6242b3c$var$track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var $b697b2a0f6242b3c$var$BaseReactiveHandler = class {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $b697b2a0f6242b3c$var$shallowReadonlyMap : $b697b2a0f6242b3c$var$readonlyMap : isShallow2 ? $b697b2a0f6242b3c$var$shallowReactiveMap : $b697b2a0f6242b3c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = $b697b2a0f6242b3c$var$isArray(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $b697b2a0f6242b3c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $b697b2a0f6242b3c$var$hasOwnProperty2;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $b697b2a0f6242b3c$var$isRef(target) ? target : receiver);
        if ($b697b2a0f6242b3c$var$isSymbol(key) ? $b697b2a0f6242b3c$var$builtInSymbols.has(key) : $b697b2a0f6242b3c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $b697b2a0f6242b3c$var$track(target, "get", key);
        if (isShallow2) return res;
        if ($b697b2a0f6242b3c$var$isRef(res)) {
            const value = targetIsArray && $b697b2a0f6242b3c$var$isIntegerKey(key) ? res : res.value;
            return isReadonly2 && $b697b2a0f6242b3c$var$isObject(value) ? $b697b2a0f6242b3c$var$readonly(value) : value;
        }
        if ($b697b2a0f6242b3c$var$isObject(res)) return isReadonly2 ? $b697b2a0f6242b3c$var$readonly(res) : $b697b2a0f6242b3c$var$reactive2(res);
        return res;
    }
};
var $b697b2a0f6242b3c$var$MutableReactiveHandler = class extends $b697b2a0f6242b3c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = $b697b2a0f6242b3c$var$isArray(target) && $b697b2a0f6242b3c$var$isIntegerKey(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $b697b2a0f6242b3c$var$isReadonly(oldValue);
            if (!$b697b2a0f6242b3c$var$isShallow(value) && !$b697b2a0f6242b3c$var$isReadonly(value)) {
                oldValue = $b697b2a0f6242b3c$var$toRaw(oldValue);
                value = $b697b2a0f6242b3c$var$toRaw(value);
            }
            if (!isArrayWithIntegerKey && $b697b2a0f6242b3c$var$isRef(oldValue) && !$b697b2a0f6242b3c$var$isRef(value)) {
                if (isOldValueReadonly) {
                    $b697b2a0f6242b3c$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target[key]);
                    return true;
                } else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : $b697b2a0f6242b3c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, $b697b2a0f6242b3c$var$isRef(target) ? target : receiver);
        if (target === $b697b2a0f6242b3c$var$toRaw(receiver) && result) {
            if (!hadKey) $b697b2a0f6242b3c$var$trigger(target, "add", key, value);
            else if ($b697b2a0f6242b3c$var$hasChanged(value, oldValue)) $b697b2a0f6242b3c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = $b697b2a0f6242b3c$var$hasOwn(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $b697b2a0f6242b3c$var$trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!$b697b2a0f6242b3c$var$isSymbol(key) || !$b697b2a0f6242b3c$var$builtInSymbols.has(key)) $b697b2a0f6242b3c$var$track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $b697b2a0f6242b3c$var$track(target, "iterate", $b697b2a0f6242b3c$var$isArray(target) ? "length" : $b697b2a0f6242b3c$var$ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
};
var $b697b2a0f6242b3c$var$ReadonlyReactiveHandler = class extends $b697b2a0f6242b3c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        $b697b2a0f6242b3c$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
    deleteProperty(target, key) {
        $b697b2a0f6242b3c$var$warn2(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $b697b2a0f6242b3c$var$mutableHandlers = /* @__PURE__ */ new $b697b2a0f6242b3c$var$MutableReactiveHandler();
var $b697b2a0f6242b3c$var$readonlyHandlers = /* @__PURE__ */ new $b697b2a0f6242b3c$var$ReadonlyReactiveHandler();
var $b697b2a0f6242b3c$var$toShallow = (value)=>value;
var $b697b2a0f6242b3c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $b697b2a0f6242b3c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $b697b2a0f6242b3c$var$toRaw(target);
        const targetIsMap = $b697b2a0f6242b3c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $b697b2a0f6242b3c$var$toShallow : isReadonly2 ? $b697b2a0f6242b3c$var$toReadonly : $b697b2a0f6242b3c$var$toReactive;
        !isReadonly2 && $b697b2a0f6242b3c$var$track(rawTarget, "iterate", isKeyOnly ? $b697b2a0f6242b3c$var$MAP_KEY_ITERATE_KEY : $b697b2a0f6242b3c$var$ITERATE_KEY);
        return $b697b2a0f6242b3c$var$extend(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $b697b2a0f6242b3c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            $b697b2a0f6242b3c$var$warn2(`${$b697b2a0f6242b3c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $b697b2a0f6242b3c$var$toRaw(this));
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $b697b2a0f6242b3c$var$createInstrumentations(readonly2, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $b697b2a0f6242b3c$var$toRaw(target);
            const rawKey = $b697b2a0f6242b3c$var$toRaw(key);
            if (!readonly2) {
                if ($b697b2a0f6242b3c$var$hasChanged(key, rawKey)) $b697b2a0f6242b3c$var$track(rawTarget, "get", key);
                $b697b2a0f6242b3c$var$track(rawTarget, "get", rawKey);
            }
            const { has: has } = $b697b2a0f6242b3c$var$getProto(rawTarget);
            const wrap = shallow ? $b697b2a0f6242b3c$var$toShallow : readonly2 ? $b697b2a0f6242b3c$var$toReadonly : $b697b2a0f6242b3c$var$toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly2 && $b697b2a0f6242b3c$var$track($b697b2a0f6242b3c$var$toRaw(target), "iterate", $b697b2a0f6242b3c$var$ITERATE_KEY);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $b697b2a0f6242b3c$var$toRaw(target);
            const rawKey = $b697b2a0f6242b3c$var$toRaw(key);
            if (!readonly2) {
                if ($b697b2a0f6242b3c$var$hasChanged(key, rawKey)) $b697b2a0f6242b3c$var$track(rawTarget, "has", key);
                $b697b2a0f6242b3c$var$track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $b697b2a0f6242b3c$var$toRaw(target);
            const wrap = shallow ? $b697b2a0f6242b3c$var$toShallow : readonly2 ? $b697b2a0f6242b3c$var$toReadonly : $b697b2a0f6242b3c$var$toReactive;
            !readonly2 && $b697b2a0f6242b3c$var$track(rawTarget, "iterate", $b697b2a0f6242b3c$var$ITERATE_KEY);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    $b697b2a0f6242b3c$var$extend(instrumentations, readonly2 ? {
        add: $b697b2a0f6242b3c$var$createReadonlyMethod("add"),
        set: $b697b2a0f6242b3c$var$createReadonlyMethod("set"),
        delete: $b697b2a0f6242b3c$var$createReadonlyMethod("delete"),
        clear: $b697b2a0f6242b3c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $b697b2a0f6242b3c$var$toRaw(this);
            const proto = $b697b2a0f6242b3c$var$getProto(target);
            const rawValue = $b697b2a0f6242b3c$var$toRaw(value);
            const valueToAdd = !shallow && !$b697b2a0f6242b3c$var$isShallow(value) && !$b697b2a0f6242b3c$var$isReadonly(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || $b697b2a0f6242b3c$var$hasChanged(value, valueToAdd) && proto.has.call(target, value) || $b697b2a0f6242b3c$var$hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $b697b2a0f6242b3c$var$trigger(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$b697b2a0f6242b3c$var$isShallow(value) && !$b697b2a0f6242b3c$var$isReadonly(value)) value = $b697b2a0f6242b3c$var$toRaw(value);
            const target = $b697b2a0f6242b3c$var$toRaw(this);
            const { has: has, get: get2 } = $b697b2a0f6242b3c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $b697b2a0f6242b3c$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $b697b2a0f6242b3c$var$checkIdentityKeys(target, has, key);
            const oldValue = get2.call(target, key);
            target.set(key, value);
            if (!hadKey) $b697b2a0f6242b3c$var$trigger(target, "add", key, value);
            else if ($b697b2a0f6242b3c$var$hasChanged(value, oldValue)) $b697b2a0f6242b3c$var$trigger(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $b697b2a0f6242b3c$var$toRaw(this);
            const { has: has, get: get2 } = $b697b2a0f6242b3c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $b697b2a0f6242b3c$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $b697b2a0f6242b3c$var$checkIdentityKeys(target, has, key);
            const oldValue = get2 ? get2.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $b697b2a0f6242b3c$var$trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $b697b2a0f6242b3c$var$toRaw(this);
            const hadItems = target.size !== 0;
            const oldTarget = $b697b2a0f6242b3c$var$isMap(target) ? new Map(target) : new Set(target);
            const result = target.clear();
            if (hadItems) $b697b2a0f6242b3c$var$trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $b697b2a0f6242b3c$var$createIterableMethod(method, readonly2, shallow);
    });
    return instrumentations;
}
function $b697b2a0f6242b3c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $b697b2a0f6242b3c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get($b697b2a0f6242b3c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $b697b2a0f6242b3c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $b697b2a0f6242b3c$var$createInstrumentationGetter(false, false)
};
var $b697b2a0f6242b3c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $b697b2a0f6242b3c$var$createInstrumentationGetter(true, false)
};
function $b697b2a0f6242b3c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $b697b2a0f6242b3c$var$toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = $b697b2a0f6242b3c$var$toRawType(target);
        $b697b2a0f6242b3c$var$warn2(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $b697b2a0f6242b3c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $b697b2a0f6242b3c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $b697b2a0f6242b3c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $b697b2a0f6242b3c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $b697b2a0f6242b3c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $b697b2a0f6242b3c$var$reactive2(target) {
    if (/* @__PURE__ */ $b697b2a0f6242b3c$var$isReadonly(target)) return target;
    return $b697b2a0f6242b3c$var$createReactiveObject(target, false, $b697b2a0f6242b3c$var$mutableHandlers, $b697b2a0f6242b3c$var$mutableCollectionHandlers, $b697b2a0f6242b3c$var$reactiveMap);
}
function $b697b2a0f6242b3c$var$readonly(target) {
    return $b697b2a0f6242b3c$var$createReactiveObject(target, true, $b697b2a0f6242b3c$var$readonlyHandlers, $b697b2a0f6242b3c$var$readonlyCollectionHandlers, $b697b2a0f6242b3c$var$readonlyMap);
}
function $b697b2a0f6242b3c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!$b697b2a0f6242b3c$var$isObject(target)) {
        $b697b2a0f6242b3c$var$warn2(`value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $b697b2a0f6242b3c$var$targetTypeMap($b697b2a0f6242b3c$var$toRawType(target));
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $b697b2a0f6242b3c$var$isReactive2(value) {
    if (/* @__PURE__ */ $b697b2a0f6242b3c$var$isReadonly(value)) return /* @__PURE__ */ $b697b2a0f6242b3c$var$isReactive2(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $b697b2a0f6242b3c$var$isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $b697b2a0f6242b3c$var$isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function $b697b2a0f6242b3c$var$isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function $b697b2a0f6242b3c$var$toRaw(observed) {
    const raw2 = observed && observed["__v_raw"];
    return raw2 ? /* @__PURE__ */ $b697b2a0f6242b3c$var$toRaw(raw2) : observed;
}
var $b697b2a0f6242b3c$var$toReactive = (value)=>$b697b2a0f6242b3c$var$isObject(value) ? /* @__PURE__ */ $b697b2a0f6242b3c$var$reactive2(value) : value;
var $b697b2a0f6242b3c$var$toReadonly = (value)=>$b697b2a0f6242b3c$var$isObject(value) ? /* @__PURE__ */ $b697b2a0f6242b3c$var$readonly(value) : value;
function $b697b2a0f6242b3c$var$isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
// packages/alpinejs/src/magics/$nextTick.js
$b697b2a0f6242b3c$var$magic("nextTick", ()=>$b697b2a0f6242b3c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$b697b2a0f6242b3c$var$magic("dispatch", (el)=>$b697b2a0f6242b3c$var$dispatch.bind($b697b2a0f6242b3c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$b697b2a0f6242b3c$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $b697b2a0f6242b3c$var$watch(getter, callback);
        cleanup(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$b697b2a0f6242b3c$var$magic("store", $b697b2a0f6242b3c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$b697b2a0f6242b3c$var$magic("data", (el)=>$b697b2a0f6242b3c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$b697b2a0f6242b3c$var$magic("root", (el)=>$b697b2a0f6242b3c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$b697b2a0f6242b3c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $b697b2a0f6242b3c$var$mergeProxies($b697b2a0f6242b3c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $b697b2a0f6242b3c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $b697b2a0f6242b3c$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $b697b2a0f6242b3c$var$globalIdMemo = {};
function $b697b2a0f6242b3c$var$findAndIncrementId(name) {
    if (!$b697b2a0f6242b3c$var$globalIdMemo[name]) $b697b2a0f6242b3c$var$globalIdMemo[name] = 0;
    return ++$b697b2a0f6242b3c$var$globalIdMemo[name];
}
function $b697b2a0f6242b3c$var$closestIdRoot(el, name) {
    return $b697b2a0f6242b3c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $b697b2a0f6242b3c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $b697b2a0f6242b3c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$b697b2a0f6242b3c$var$magic("id", (el, { cleanup: cleanup })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $b697b2a0f6242b3c$var$cacheIdByNameOnElement(el, cacheKey, cleanup, ()=>{
            let root = $b697b2a0f6242b3c$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $b697b2a0f6242b3c$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$b697b2a0f6242b3c$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $b697b2a0f6242b3c$var$cacheIdByNameOnElement(el, cacheKey, cleanup, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$b697b2a0f6242b3c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$b697b2a0f6242b3c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$b697b2a0f6242b3c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $b697b2a0f6242b3c$var$warnMissingPluginMagic(name, magicName, slug) {
    $b697b2a0f6242b3c$var$magic(magicName, (el)=>$b697b2a0f6242b3c$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$b697b2a0f6242b3c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $b697b2a0f6242b3c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$b697b2a0f6242b3c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $b697b2a0f6242b3c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $b697b2a0f6242b3c$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $b697b2a0f6242b3c$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $b697b2a0f6242b3c$var$mutateDom(()=>{
        $b697b2a0f6242b3c$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $b697b2a0f6242b3c$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $b697b2a0f6242b3c$var$getTarget(expression);
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup(()=>$b697b2a0f6242b3c$var$mutateDom(()=>{
            clone2.remove();
            $b697b2a0f6242b3c$var$destroyTree(clone2);
        }));
});
var $b697b2a0f6242b3c$var$teleportContainerDuringClone = document.createElement("div");
function $b697b2a0f6242b3c$var$getTarget(expression) {
    let target = $b697b2a0f6242b3c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $b697b2a0f6242b3c$var$teleportContainerDuringClone;
    })();
    if (!target) $b697b2a0f6242b3c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $b697b2a0f6242b3c$var$handler = ()=>{};
$b697b2a0f6242b3c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$b697b2a0f6242b3c$var$directive("ignore", $b697b2a0f6242b3c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$b697b2a0f6242b3c$var$directive("effect", $b697b2a0f6242b3c$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($b697b2a0f6242b3c$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $b697b2a0f6242b3c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $b697b2a0f6242b3c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $b697b2a0f6242b3c$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $b697b2a0f6242b3c$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($b697b2a0f6242b3c$var$isKeyEvent(event) || $b697b2a0f6242b3c$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($b697b2a0f6242b3c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $b697b2a0f6242b3c$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $b697b2a0f6242b3c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $b697b2a0f6242b3c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $b697b2a0f6242b3c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $b697b2a0f6242b3c$var$throttle(handler4, wait);
    }
    return handler4;
}
function $b697b2a0f6242b3c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $b697b2a0f6242b3c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $b697b2a0f6242b3c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $b697b2a0f6242b3c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $b697b2a0f6242b3c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $b697b2a0f6242b3c$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
var $b697b2a0f6242b3c$var$nonKeyModifiers = [
    // x-on's own modifiers:
    "window",
    "document",
    "prevent",
    "stop",
    "once",
    "capture",
    "self",
    "away",
    "outside",
    "passive",
    "dot",
    "camel",
    "preserve-scroll",
    // x-model's own modifiers:
    "blur",
    "change",
    "lazy",
    "number",
    "boolean",
    "trim",
    "fill",
    "unintrusive",
    "parent"
];
function $b697b2a0f6242b3c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((modifier, index)=>{
        if (modifier === "false" && modifiers[index - 1] === "passive") return false;
        return !$b697b2a0f6242b3c$var$nonKeyModifiers.includes(modifier);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $b697b2a0f6242b3c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $b697b2a0f6242b3c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $b697b2a0f6242b3c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($b697b2a0f6242b3c$var$isClickEvent(e.type)) return false;
            if ($b697b2a0f6242b3c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $b697b2a0f6242b3c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $b697b2a0f6242b3c$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$b697b2a0f6242b3c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $b697b2a0f6242b3c$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $b697b2a0f6242b3c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $b697b2a0f6242b3c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $b697b2a0f6242b3c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $b697b2a0f6242b3c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($b697b2a0f6242b3c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $b697b2a0f6242b3c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($b697b2a0f6242b3c$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($b697b2a0f6242b3c$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($b697b2a0f6242b3c$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($b697b2a0f6242b3c$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($b697b2a0f6242b3c$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove2)=>remove2());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $b697b2a0f6242b3c$var$on(el, event, modifiers, (e)=>{
            setValue($b697b2a0f6242b3c$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $b697b2a0f6242b3c$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($b697b2a0f6242b3c$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $b697b2a0f6242b3c$var$on(el.form, "reset", [], (e)=>{
            $b697b2a0f6242b3c$var$nextTick(()=>el._x_model && el._x_model.set($b697b2a0f6242b3c$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $b697b2a0f6242b3c$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            if ($b697b2a0f6242b3c$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($b697b2a0f6242b3c$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $b697b2a0f6242b3c$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $b697b2a0f6242b3c$var$bind(el, "value", value);
        });
    };
    if (el.tagName === "SELECT") {
        let observer2 = new MutationObserver(()=>{
            el._x_forceModelUpdate(getValue());
        });
        observer2.observe(el, {
            childList: true
        });
        cleanup(()=>observer2.disconnect());
    }
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $b697b2a0f6242b3c$var$getInputValue(el, modifiers, event, currentValue) {
    return $b697b2a0f6242b3c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($b697b2a0f6242b3c$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $b697b2a0f6242b3c$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $b697b2a0f6242b3c$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$b697b2a0f6242b3c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $b697b2a0f6242b3c$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $b697b2a0f6242b3c$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($b697b2a0f6242b3c$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $b697b2a0f6242b3c$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $b697b2a0f6242b3c$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $b697b2a0f6242b3c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $b697b2a0f6242b3c$var$isNumeric2(number) ? number : rawValue;
}
function $b697b2a0f6242b3c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $b697b2a0f6242b3c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $b697b2a0f6242b3c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$b697b2a0f6242b3c$var$directive("cloak", (el)=>{
    if ($b697b2a0f6242b3c$var$isCloning) return el.removeAttribute($b697b2a0f6242b3c$var$prefix("cloak"));
    queueMicrotask(()=>$b697b2a0f6242b3c$var$mutateDom(()=>el.removeAttribute($b697b2a0f6242b3c$var$prefix("cloak"))));
});
// packages/alpinejs/src/directives/x-init.js
$b697b2a0f6242b3c$var$addInitSelector(()=>`[${$b697b2a0f6242b3c$var$prefix("init")}]`);
$b697b2a0f6242b3c$var$directive("init", $b697b2a0f6242b3c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$b697b2a0f6242b3c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $b697b2a0f6242b3c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$b697b2a0f6242b3c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $b697b2a0f6242b3c$var$mutateDom(()=>{
                Array.from(el.children).forEach((child)=>$b697b2a0f6242b3c$var$destroyTree(child));
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $b697b2a0f6242b3c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    }, {
        priority: "structural"
    });
});
// packages/alpinejs/src/directives/x-bind.js
$b697b2a0f6242b3c$var$mapAttributes($b697b2a0f6242b3c$var$startingWith(":", $b697b2a0f6242b3c$var$into($b697b2a0f6242b3c$var$prefix("bind:"))));
var $b697b2a0f6242b3c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup })=>{
    if (!value) {
        let bindingProviders = {};
        $b697b2a0f6242b3c$var$injectBindingProviders(bindingProviders);
        let getBindings = $b697b2a0f6242b3c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $b697b2a0f6242b3c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $b697b2a0f6242b3c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $b697b2a0f6242b3c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $b697b2a0f6242b3c$var$mutateDom(()=>$b697b2a0f6242b3c$var$bind(el, value, result, modifiers));
        }));
    cleanup(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$b697b2a0f6242b3c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$b697b2a0f6242b3c$var$directive("bind", $b697b2a0f6242b3c$var$handler2);
function $b697b2a0f6242b3c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$b697b2a0f6242b3c$var$addRootSelector(()=>`[${$b697b2a0f6242b3c$var$prefix("data")}]`);
var $b697b2a0f6242b3c$var$dataForReconciliation = Symbol();
$b697b2a0f6242b3c$var$directive("data", (el, { expression: expression }, { cleanup: cleanup })=>{
    if ($b697b2a0f6242b3c$var$shouldSkipRegisteringDataDuringClone(el)) return;
    let dataToReconcile = el[$b697b2a0f6242b3c$var$dataForReconciliation];
    if (dataToReconcile?.expression === expression) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $b697b2a0f6242b3c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $b697b2a0f6242b3c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $b697b2a0f6242b3c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $b697b2a0f6242b3c$var$injectMagics(data2, el);
    let reactiveData;
    if (dataToReconcile?.reactiveData) {
        reactiveData = dataToReconcile.reactiveData;
        $b697b2a0f6242b3c$var$reconcileData(reactiveData, data2);
        let initialized = {
            expression: expression
        };
        el[$b697b2a0f6242b3c$var$dataForReconciliation] = initialized;
        queueMicrotask(()=>{
            if (el[$b697b2a0f6242b3c$var$dataForReconciliation] === initialized) delete el[$b697b2a0f6242b3c$var$dataForReconciliation];
        });
    } else reactiveData = $b697b2a0f6242b3c$var$reactive(data2);
    $b697b2a0f6242b3c$var$initInterceptors(reactiveData, cleanup);
    let undo = $b697b2a0f6242b3c$var$addScopeToNode(el, reactiveData);
    $b697b2a0f6242b3c$var$skipDuringClone(()=>{
        reactiveData["init"] && $b697b2a0f6242b3c$var$evaluate(el, reactiveData["init"]);
    })();
    cleanup(()=>{
        reactiveData["destroy"] && $b697b2a0f6242b3c$var$evaluate(el, reactiveData["destroy"]);
        undo();
        let removed = {
            reactiveData: reactiveData
        };
        el[$b697b2a0f6242b3c$var$dataForReconciliation] = removed;
        queueMicrotask(()=>{
            if (el[$b697b2a0f6242b3c$var$dataForReconciliation] === removed) delete el[$b697b2a0f6242b3c$var$dataForReconciliation];
        });
    });
});
function $b697b2a0f6242b3c$var$reconcileData(target, source) {
    Object.keys(source).forEach((key)=>{
        let descriptor = Object.getOwnPropertyDescriptor(source, key);
        let existingDescriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get || descriptor.set || existingDescriptor?.get || existingDescriptor?.set) {
            if (existingDescriptor) delete target[key];
            if (!existingDescriptor) target[key] = void 0;
            descriptor.get || descriptor.set ? Object.defineProperty(target, key, descriptor) : target[key] = source[key];
        } else target[key] = source[key];
    });
    Object.keys(target).filter((key)=>!Object.prototype.hasOwnProperty.call(source, key)).forEach((key)=>delete target[key]);
}
$b697b2a0f6242b3c$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $b697b2a0f6242b3c$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$b697b2a0f6242b3c$var$isCloning) return false;
    if ($b697b2a0f6242b3c$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$b697b2a0f6242b3c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $b697b2a0f6242b3c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $b697b2a0f6242b3c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$b697b2a0f6242b3c$var$directive("for", $b697b2a0f6242b3c$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let iteratorNames = $b697b2a0f6242b3c$var$parseForExpression(expression);
    let evaluateItems = $b697b2a0f6242b3c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $b697b2a0f6242b3c$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$b697b2a0f6242b3c$var$loop(el, iteratorNames, evaluateItems, evaluateKey), {
        priority: "structural"
    });
    cleanup(()=>{
        el._x_lookup.forEach((el2)=>$b697b2a0f6242b3c$var$mutateDom(()=>{
                $b697b2a0f6242b3c$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
        delete el._x_lastRenderedEl;
    });
}));
function $b697b2a0f6242b3c$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $b697b2a0f6242b3c$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($b697b2a0f6242b3c$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $b697b2a0f6242b3c$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $b697b2a0f6242b3c$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $b697b2a0f6242b3c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $b697b2a0f6242b3c$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $b697b2a0f6242b3c$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $b697b2a0f6242b3c$var$reactive(scope2);
                $b697b2a0f6242b3c$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $b697b2a0f6242b3c$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            added.forEach((clone2)=>$b697b2a0f6242b3c$var$initTree(clone2));
            if (prev !== templateEl) templateEl._x_lastRenderedEl = prev;
            else delete templateEl._x_lastRenderedEl;
        });
    });
}
function $b697b2a0f6242b3c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\b(?:in|of)\b([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $b697b2a0f6242b3c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $b697b2a0f6242b3c$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $b697b2a0f6242b3c$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $b697b2a0f6242b3c$var$handler3() {}
$b697b2a0f6242b3c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup })=>{
    let root = $b697b2a0f6242b3c$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup(()=>delete root._x_refs[expression]);
};
$b697b2a0f6242b3c$var$directive("ref", $b697b2a0f6242b3c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$b697b2a0f6242b3c$var$directive("if", $b697b2a0f6242b3c$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $b697b2a0f6242b3c$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $b697b2a0f6242b3c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $b697b2a0f6242b3c$var$addScopeToNode(clone2, {}, el);
        $b697b2a0f6242b3c$var$mutateDom(()=>{
            el.after(clone2);
            $b697b2a0f6242b3c$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_lastRenderedEl = clone2;
        el._x_undoIf = ()=>{
            $b697b2a0f6242b3c$var$mutateDom(()=>{
                $b697b2a0f6242b3c$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
            delete el._x_lastRenderedEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }), {
        priority: "structural"
    });
    cleanup(()=>el._x_undoIf && el._x_undoIf());
}));
// packages/alpinejs/src/directives/x-id.js
$b697b2a0f6242b3c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$b697b2a0f6242b3c$var$setIdRoot(el, name));
});
$b697b2a0f6242b3c$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$b697b2a0f6242b3c$var$mapAttributes($b697b2a0f6242b3c$var$startingWith("@", $b697b2a0f6242b3c$var$into($b697b2a0f6242b3c$var$prefix("on:"))));
$b697b2a0f6242b3c$var$directive("on", $b697b2a0f6242b3c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    let evaluate2 = expression ? $b697b2a0f6242b3c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $b697b2a0f6242b3c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$b697b2a0f6242b3c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$b697b2a0f6242b3c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$b697b2a0f6242b3c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$b697b2a0f6242b3c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $b697b2a0f6242b3c$var$warnMissingPluginDirective(name, directiveName, slug) {
    $b697b2a0f6242b3c$var$directive(directiveName, (el)=>$b697b2a0f6242b3c$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$b697b2a0f6242b3c$var$alpine_default.setEvaluator($b697b2a0f6242b3c$var$normalEvaluator);
$b697b2a0f6242b3c$var$alpine_default.setRawEvaluator($b697b2a0f6242b3c$var$normalRawEvaluator);
$b697b2a0f6242b3c$var$alpine_default.setReactivityEngine({
    reactive: $b697b2a0f6242b3c$var$reactive2,
    // Since Vue 3.2, the scheduler is called with no arguments, so we wrap
    // the effect to hand Alpine's scheduler the runner it expects to queue.
    effect: (callback, options = {})=>{
        let runner;
        runner = $b697b2a0f6242b3c$var$effect2(callback, {
            scheduler: ()=>{
                if (!runner) return;
                options.scheduler ? options.scheduler(runner) : runner();
            }
        });
        return runner;
    },
    release: $b697b2a0f6242b3c$var$stop,
    raw: $b697b2a0f6242b3c$var$toRaw
});
var $b697b2a0f6242b3c$export$b7ee041e4ad2afec = $b697b2a0f6242b3c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $b697b2a0f6242b3c$export$2e2bcd8739ae039 = $b697b2a0f6242b3c$export$b7ee041e4ad2afec;
 /*! Bundled license information:

@vue/shared/dist/shared.esm-bundler.js:
  (**
  * @vue/shared v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

@vue/reactivity/dist/reactivity.esm-bundler.js:
  (**
  * @vue/reactivity v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
*/ 

// packages/collapse/src/index.js
function $90e52979970ba831$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $90e52979970ba831$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $90e52979970ba831$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $90e52979970ba831$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $90e52979970ba831$export$2e2bcd8739ae039 = $90e52979970ba831$export$ec45920981e0ca9b;


var $f190b1c38e1f62be$export$2e2bcd8739ae039 = ()=>{
    const items = document.querySelectorAll('.color-variable-item');
    const form = document.querySelector('.wcpa_form_outer');
    const resetButton = document.querySelector('.reset_variations');
    const inputField = document.querySelector('.wcpa_field');
    if (!items || !form) return;
    items.forEach((item)=>{
        item.addEventListener('click', ()=>{
            if (item.classList.contains('color-variable-item-other')) form.classList.add('is-active');
            else {
                inputField.value = '';
                form.classList.remove('is-active');
            }
        });
    });
    resetButton.addEventListener('click', ()=>{
        form.classList.remove('is-active');
        resetButton.style.display = 'none';
        inputField.value = '';
    });
};


var $83c1b60a731feddb$export$2e2bcd8739ae039 = ()=>{
    const form_checkbox_1 = document.getElementById('form1');
    const form_checkbox_2 = document.getElementById('form2');
    const form_1 = document.querySelector('.forms__form-1');
    const form_2 = document.querySelector('.forms__form-2');
    let params = new URLSearchParams(document.location.search);
    if (!form_checkbox_1 || !form_checkbox_2) return;
    if (params.get("subject") === 'information') {
        form_checkbox_2.setAttribute('checked', 'checked');
        form_2.style.display = 'block';
        form_1.style.display = 'none';
    }
    form_checkbox_1.addEventListener('click', ()=>{
        form_1.style.display = 'block';
        form_2.style.display = 'none';
    });
    form_checkbox_2.addEventListener('click', ()=>{
        form_2.style.display = 'block';
        form_1.style.display = 'none';
    });
};


var $64a8a4f198302e5f$export$2e2bcd8739ae039 = ()=>{
    const items = document.querySelectorAll('.color-variable-item');
    items.forEach((item)=>{
        item.addEventListener('mouseenter', ()=>{
            const color = item.querySelector('.variable-item-span-color');
            if (color) {
                const style = window.getComputedStyle(color);
                const backgroundColor = style.backgroundColor;
                item.style.setProperty('--item-before-background-color', backgroundColor);
            }
        });
        item.addEventListener('mouseleave', ()=>{
            item.style.removeProperty('--item-before-background-color');
        });
    });
};


var $e5e7ac1bea83bec9$export$2e2bcd8739ae039 = ()=>{
    const input = document.querySelector('.quantity  > input.qty');
    const rules = document.querySelectorAll('.dynamic-pricing__item');
    if (!rules && !input) return;
    rules.forEach((rule)=>{
        rule.addEventListener('click', ()=>{
            input.value = rule.getAttribute('data-quantity');
        });
    });
};


(0, $b697b2a0f6242b3c$export$2e2bcd8739ae039).plugin((0, $90e52979970ba831$export$2e2bcd8739ae039));
(0, $b697b2a0f6242b3c$export$2e2bcd8739ae039).start();
(0, $3246626f326b5786$export$28ee1007e174a2a6)(()=>{
    (0, $3c70f802c91490c5$export$2e2bcd8739ae039)();
    (0, $f190b1c38e1f62be$export$2e2bcd8739ae039)();
    (0, $40363820c3e434e5$export$2e2bcd8739ae039)();
    (0, $83c1b60a731feddb$export$2e2bcd8739ae039)();
    (0, $64a8a4f198302e5f$export$2e2bcd8739ae039)();
    (0, $e5e7ac1bea83bec9$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=app.js.map
